import productImg01 from "../Images/double-sofa-01.png";
import productImg02 from "../Images/double-sofa-02.png";
import productImg03 from "../Images/double-sofa-03.png";

import productImg04 from "../Images/single-sofa-01.jpg";
import productImg05 from "../Images/single-sofa-02.jpg";
import productImg06 from "../Images/single-sofa-03.jpg";
import productImg007 from "../Images/single-sofa-04.png";

import productImg07 from "../Images/arm-chair-01.jpg";
import productImg08 from "../Images/arm-chair-02.jpg";
import productImg09 from "../Images/arm-chair-03.jpg";
import productImg10 from "../Images/arm-chair-01.jpg";

import phone01 from "../Images/phone-01.jpg";
import phone02 from "../Images/phone-02.jpg";
import phone03 from "../Images/phone-03.png";
import phone04 from "../Images/phone-04.jpg";
import phone05 from "../Images/phone-05.jpg";
import phone06 from "../Images/phone-06.jpg";
import phone08 from "../Images/phone-08.png";

import watch01 from "../Images/watch-01.jpg";
import watch02 from "../Images/watch-02.jpg";
import watch03 from "../Images/watch-03.jpg";
import watch04 from "../Images/watch-04.jpg";

import wireless01 from "../Images/wireless-01.png";
import wireless02 from "../Images/wireless-02.png";
import wireless03 from "../Images/wireless-03.png";
import wireless04 from "../Images/wireless-04.png";

import sofaSlide from "../Images/hero-img.png";
import watchSlide from "../Images/watch-07.png";

import populartest01 from "../Images/test-image-01.avif";
import slider01 from "../Images/slide-show-01.png";
import slider02 from "../Images/slide-show-02.jpg";
import bloodTest01 from "../Images/blood-test-01.avif";
import FemaleAdvancePackage from "../Images/FemaleAdvancePackage.jpg";
import maleadvancepackage from "../Images/maleadvancepackage.jpg";
import FemaleSeniorCitizen from "../Images/FemaleSeniorCitizen.jpg";
import seniorcitizen from "../Images/seniorcitizen.jpg";
import GenaralHealthPackage from "../Images/GenaralHealthPackage.jpg";
import banner from "../Images/banner.png";
import Untitleddesign from "../Images/Untitleddesign.png";
import fullBody from "../Images/fullBody.png";
import heart from "../Images/heart.png";
import diabetes from "../Images/diabetes.png";
import fever from "../Images/fever.png";
import thyroid from "../Images/thyroid.png";
import cancer from "../Images/cancer.png";
import hair from "../Images/hair.png";
import std from "../Images/std.png";
import underTwentyFive from "../Images/underTwentyFive.png";
import twentyFive from "../Images/twentyFive.png";
import aboveFifty from "../Images/aboveFifty.png";
import moreMenPackages from "../Images/moreMenPackages.png";
import underTwentyFiveWomen from "../Images/underTwentyFiveWomen.png";
import twentyFiveWomen from "../Images/TwentyFiveWomen.png";
import aboveFiftyWomen from "../Images/aboveFiftyWomen.png";
import moreWomenPackages from "../Images/moreWomenPackages.png";

export const SliderData = [
  {
    id: 1,
    title: "Book Your Test Now",
    desc: "Book Your Test Now near by to your place .",
    cover: banner,
  },
  // {
  //   id: 2,
  //   title: "We serve all around the country",
  //   desc: "Book your Test now.",
  //   cover: banner,
  // },
];

export const serviceData = [
  {
    icon: <ion-icon name="globe-outline"></ion-icon>,
    title: "Book Your Test Online",
    bg: "#d6e5fb",
  },
  {
    icon: <ion-icon name="home-outline"></ion-icon>,
    title: "Home Sample Pick Up",
    bg: "#ceebe9",
  },
  {
    icon: <ion-icon name="shield-half-outline"></ion-icon>,
    title: "We Process in NABL AND ISO Certified Labs",
    bg: "#d6e5fb",
  },
  {
    icon: <ion-icon name="newspaper-outline"></ion-icon>,
    title: "View Your Reports Online",
    bg: "#ceebe9",
  },
];


export const healthConcerns = [
  {
    id: "01",
    imgUrl: fullBody,
    name: "Full Body Checkups",
    packageIds: ["80", "42", "41", "59", "48", "06", "05", "04"],
  },
  {
    id: "02",
    imgUrl: heart,
    name: "Heart",
    packageIds: ["32", "31", "94", "146", "57", "147", "06"],
  },
  {
    id: "03",
    imgUrl: diabetes,
    name: "Diabetes",
    packageIds: ["25", "26", "148", "149"],
  },
  {
    id: "04",
    imgUrl: fever,
    name: "Fever",
    packageIds: ["150", "151", "152"],
  },
  {
    id: "05",
    imgUrl: thyroid,
    name: "Thyroid",
    packageIds: ["30", "29", "60", "127"],
  },
  {
    id: "06",
    imgUrl: cancer,
    name: "Cancer",
    packageIds: ["27", "28", "18", "19"],
  },
  {
    id: "07",
    imgUrl: hair,
    name: "Hair",
    packageIds: ["153", "154", "155", "156"],
  },
  {
    id: "08",
    imgUrl: std,
  },
];

export const checkupsMen = [
  {
    id: "01",
    imgUrl: underTwentyFive,
  },
  {
    id: "02",
    imgUrl: twentyFive,
  },
  {
    id: "03",
    imgUrl: aboveFifty,
  },
  {
    id: "04",
    imgUrl: moreMenPackages,
  },
];

export const checkupsWomen = [
  {
    id: "01",
    imgUrl: underTwentyFiveWomen,
  },
  {
    id: "02",
    imgUrl: twentyFiveWomen,
  },
  {
    id: "03",
    imgUrl: aboveFiftyWomen,
  },
  {
    id: "04",
    imgUrl: moreWomenPackages,
  },
];

export const discoutProducts = [
  {
    id: "01",
    productName: "BASIC HEALTH PACKAGE (66 Tests)",
    desc: "Tests includes Cardiac Risk Markers, CBC, HbA1c, Iron, Lipid, Liver, Kidney, Thyroid, Vitamin, Pancreas, Electrolytes.",
    includedTests: [
      {
        categoryName: "Thyroid Profile",
        tests: ["01", "02"],
      },
      {
        categoryName: "Lipid Profile",
        tests: ["03", "04", "05"],
      },
      // ... more categories can be added similarly
    ],
    imgUrl: populartest01,
    category: "sofa",
    price: 1199.0,
    discount: 30,
    shortDesc: "Sample Type: Blood",
    description:
      "Full body checkup is an essential health test that can detect hidden diseases. Reliable pathology labs like Fortune Blood Test offer a perfect solution to this challenge by providing comprehensive health packages with blood test at home services. These preventive health checkups include specific tests recommended by certified doctors and expert pathologists. It is a great way to stay on top of your health and take proactive measures to prevent any potential health issues.",
    reviews: [
      {
        rating: 4.7,
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
      },
    ],
    avgRating: 4.5,
    overlayTitle: "Aarogyam Male (99 Tests) @ Rs. 2199.00",
    overlayDetails: [
      "Cardiac Risk Markers (5)",
      "Complete Hemogram (24)",
      "Diabetics (2)",
      "Iron (4)",
      "Lipid Profile (10)",
    ],
  },
  {
    id: "28",
    productName: "Jaanch - Tumour Panel (Female) (6 Tests)",
    type: "package",
    includedTests: [
      {
        categoryName: "CANCER MARKERS (Includes 4 tests)",
        tests: [
          "Ca-125",
          "Ca 15.3",
          "Ca 19.9",
          "Carcino embryonic antigen (cea)",
        ],
      },
      {
        categoryName: "OTHERS (Includes 1 tests)",
        tests: ["Alpha feto protein (afp)"],
      },
      {
        categoryName: "PREGNANCY (Includes 1 tests)",
        tests: ["Beta hcg"],
      },
    ],
    desc: "Tests Includes CANCER MARKERS, OTHERS, PREGNANCY",
    imgUrl: populartest01,
    category: "Basic",
    mrp: 3998.0,
    price: 1999.0,
    discount: 30,
    shortDesc: "Sample Type: Blood",
    description:
      "Jaanch - Tumour Panel (Female) gives you an accurate diagnosis of cancer at an early stage. Consisting of 6 parameters, the panel helps doctors understand the specific type of cancer, plan a treatment or check the progress of treatment. You can also take this test if you have just finished your cancer treatment, if you have a family history of cancer or if you are at risk due to factors like obesity, smoking, old age, and preexisting health conditions. Get Thyrocare's Jaanch - Tumour Panel (Female) at affordable rates with FREE home sample collection.",
    reviews: [
      {
        rating: 4.7,
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
      },
    ],
    overlayTitle: "Jaanch - Tumour Panel (Female)",
    overlayDetails: ["CANCER MARKERS (4)", "OTHERS (1)", "PREGNANCY (1)"],
    avgRating: 4.5,
  },

  {
    id: "03",
    productName: "Male Advanced Health Package (105 Tests)",
    includedTests: [
      {
        categoryName: "Thyroid Profile",
        tests: ["01", "02"],
      },
      {
        categoryName: "Lipid Profile",
        tests: ["03", "04", "05"],
      },
      // ... more categories can be added similarly
    ],
    imgUrl: maleadvancepackage,
    category: "sofa",
    price: 1199.0,
    discount: 30,
    shortDesc: "Sample Type: Blood",
    description:
      "The MALE ADVANCED HEALTH PACKAGE includes 105 vital tests to screen health status, such as Cardiac Risk Markers, Complete Hemogram, Diabetes, Iron, Lipid, Liver, Kidney, Thyroid, Vitamins, Pancreatic, Electrolytes, CEA (a type of Tumour Marker), Prostate Cancer (PSA), and Hormones. This package is recommended for men aged between 25 and 50 years.",
    reviews: [
      {
        rating: 4.7,
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
      },
    ],
    avgRating: 4.5,
  },
  {
    id: "04",
    productName: "Female Senior Citizen Health Package (108 Tests)",
    includedTests: [
      {
        categoryName: "Thyroid Profile",
        tests: ["01", "02"],
      },
      {
        categoryName: "Lipid Profile",
        tests: ["03", "04", "05"],
      },
      // ... more categories can be added similarly
    ],
    imgUrl: FemaleSeniorCitizen,
    category: "sofa",
    price: 1199.0,
    discount: 30,
    shortDesc: "Sample Type: Blood",
    description:
      "Full body checkup is an essential health test that can detect hidden diseases. Reliable pathology labs like Fortune Blood Test offer a perfect solution to this challenge by providing comprehensive health packages with blood test at home services. These preventive health checkups include specific tests recommended by certified doctors and expert pathologists. It is a great way to stay on top of your health and take proactive measures to prevent any potential health issues.",
    reviews: [
      {
        rating: 4.7,
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
      },
    ],
    avgRating: 4.5,
  },
  {
    id: "05",
    productName: "Male Senior Citizen Health Package (108 Tests)",
    includedTests: [
      {
        categoryName: "Thyroid Profile",
        tests: ["01", "02"],
      },
      {
        categoryName: "Lipid Profile",
        tests: ["03", "04", "05"],
      },
      // ... more categories can be added similarly
    ],
    imgUrl: seniorcitizen,
    category: "sofa",
    price: 1199.0,
    discount: 30,
    shortDesc: "Sample Type: Blood",
    description:
      "Full body checkup is an essential health test that can detect hidden diseases. Reliable pathology labs like Fortune Blood Test offer a perfect solution to this challenge by providing comprehensive health packages with blood test at home services. These preventive health checkups include specific tests recommended by certified doctors and expert pathologists. It is a great way to stay on top of your health and take proactive measures to prevent any potential health issues.",
    reviews: [
      {
        rating: 4.7,
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
      },
    ],
    avgRating: 4.5,
  },
  {
    id: "06",
    productName: "General Health Package (111 Tests)",
    includedTests: [
      {
        categoryName: "Thyroid Profile",
        tests: ["01", "02"],
      },
      {
        categoryName: "Lipid Profile",
        tests: ["03", "04", "05"],
      },
      // ... more categories can be added similarly
    ],
    imgUrl: GenaralHealthPackage,
    category: "sofa",
    price: 1199.0,
    discount: 30,
    shortDesc: "Sample Type: Blood",
    description:
      "Full body checkup is an essential health test that can detect hidden diseases. Reliable pathology labs like Fortune Blood Test offer a perfect solution to this challenge by providing comprehensive health packages with blood test at home services. These preventive health checkups include specific tests recommended by certified doctors and expert pathologists. It is a great way to stay on top of your health and take proactive measures to prevent any potential health issues.",
    reviews: [
      {
        rating: 4.7,
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
      },
    ],
    avgRating: 4.5,
  },
];

export const products = [
  {
    id: "P01",
    productName: "Fasting Blood Sugar",
    type: "product",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 80,
    description:
      "The fasting blood sugar (FBS) test determines the actual concentration of glucose in your blood without consumption of any diet. FBS test is frequently recommended in patients to determine whether glucose levels are controlled by the injection of insulin hormone in case of type 1 diabetes and whether the body is able to use insulin in case of type 2 diabetes. Elevated levels of fasting blood sugar can be an indication of Type 1 or Type 2 Diabetes. If untreated, can lead to severe health-related consequences like delayed wound healing, damage to the eyes (Diabetic retinopathy), kidney (renal failure), nerves (peripheral neuropathy), and heart (myocardial infarction). Book your FBS Test at a low cost and get a home collection facility.",
  },
  {
    id: "2",
    productName: "Hba1c",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 350,
    description:
      "HbA1c, also known as Hemoglobin A1c or A1c, is glycosylated hemoglobin or glycohemoglobin in which the glucose molecule present in the blood non-enzymatically binds to hemoglobin. HbA1c test reflects those RBC that are present in the blood at the time of test and measures average blood glucose concentration over 3-4 months. This gives an indication of long-term blood glucose control which serves as a regular monitoring tool if a person has been diagnosed with diabetes. According to the American Diabetes Association, this test is mandatory for diabetic patients and should be performed four times a year. HbA1c test is available at a discounted rate, along with the home collection.",
  },
  {
    id: "3",
    productName: "Postprandial Blood Sugar",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 80,
    description:
      "The postprandial blood sugar determines the glucose concentration 2 hours after having breakfast/ lunch. Blood sugar levels usually begin to rise 10-15 minutes after a meal and reach their peak after an hour. The pancreas produces the hormone insulin, which aids in the absorption of sugar from the bloodstream into the body cells. This test is used to assess how the body reacts to sugar and starch after eating a meal. Doctors recommend this test if your blood sugar continues to be excessively high or extremely low. Blood sugar levels in people who do not have diabetes normally return to normal within 2 hours.",
  },
  {
    id: "4",
    productName: "Erythrocyte Sedimentation Rate (ESR)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 120,
    description:
      "Erythrocyte Sedimentation Rate (ESR) test includes measuring the rate at which red blood cells from the anticoagulated blood settle when kept standing in a tube. This is termed Erythrocyte Sedimentation Rate (ESR). Thyrocare offer ESR test at a very affordable price, home collection available.",
  },
  {
    id: "5",
    productName: "Free Thyroxine (Ft4)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 260,
    description:
      "FT4 is the free T4 that is not bound to the proteins and is related to thyroid metabolism. Low levels of FT4 indicate hypothyroidism and raised levels are associated with hyperthyroidism. Thyrocare offers a Free Thyroxine test at a very affordable price along with a home collection.",
  },
  {
    id: "6",
    productName: "C-Reactive Protein (Crp)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 480,
    description:
      "The test detects the presence of CRP in blood. CRP is produced by the liver in response to inflammatory conditions, like infection, trauma, heart and autoimmune diseases. The test also helps in monitoring treatment post infection and inflammation. Book the CRP test at an affordable price and get a free home sample collection.",
  },
  {
    id: "7",
    productName: "Beta Hcg",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 770,
    description:
      "A rapid rise in the level of hCG indicates pregnancy. The test is used for early confirmation of pregnancy and to monitor it. Get Thyrocare's Beta hCG test at home with our free home collection service. Book now.",
  },
  {
    id: "8",
    productName: "Prolactin (Prl)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 530,
    description:
      "Prolactin is secreted by the pituitary gland and triggers milk production in women. Abnormal levels can be seen in several health conditions like menstrual problems, pituitary tumors, fertility issues, and others, thus needs to be monitored. Book Prolactin test now to avail yourself services at your doorstep, at very affordable rates.",
  },
  {
    id: "9",
    productName: "Free Triiodothyronine (Ft3)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 260,
    description:
      "Estimation of FT3 and FT4 hormone levels improves the sensitivity and accuracy of diagnosing thyroid dysfunctions. When only T3 - T4 levels are measured, it may become difficult to reach a definitive diagnosis many times.",
  },
  {
    id: "10",
    productName: "Prostate Specific Antigen (Psa)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 600,
    description:
      "Prostate-specific antigen (PSA), is a glycoprotein produced by cells of the prostate that remains free in the blood. A free PSA test measures the amount of unbound prostate-specific antigen in the blood, which helps physicians to identify problems such as prostate inflammation or tumor. Levels of PSA rise in conditions such as prostate cancer and also in benign prostatic hyperplasia (BPH). Monitoring free PSA is useful for detecting metastatic or chronic disease in patients receiving anti-prostate cancer therapy. If the levels of PSA are elevated after treatment, it indicates the recurrence of the disease. Now book your PSA test at an affordable price, with a  home collection service from Thyrocare.",
  },
  {
    id: "11",
    productName: "vitamin b-12",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 900,
    description:
      "Vitamin B-12 is required for neuronal brain development and to boost immunity. Monitoring its levels is essential to prevent health complications and memory problems. Book a Vitamin B12 test from Thyrocare and get services at your doorstep at very affordable rates.",
  },
  {
    id: "12",
    productName: "Rheumatoid Factor (Rf)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 620,
    description:
      "Rheumatoid Factor (RF) is an immunoglobulin M protein, produced by the body’s immune system. This protein attacks the body’s tissues as it mistakenly identifies them as a foreign entity. The rheumatoid factor test determines the level of rheumatoid factor in your blood to diagnose rheumatoid arthritis. Higher RF concentrations are often linked to autoimmune disorders such as rheumatoid arthritis and Sjogren's syndrome. Other conditions that may elevate RF concentration in the blood include hepatitis, viral or bacterial infections, and endocarditis. There is also a gradual rise in RF levels with age. Book a Rheumatoid Factor test from Thyrocare to avail of the service at your doorsteps at a low cost.",
  },
  {
    id: "13",
    productName: "Anti Hepatitis C Virus (Anti Hcv) - Total",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1180,
  },
  {
    id: "14",
    productName: "hiv I and Ii",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 520,
  },
  {
    id: "15",
    productName: "Hepatitis B Surface Antigen (Hbsag)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 480,
    description:
      "Hepatitis B surface antigen (HBsAg) test is used to screen and diagnose acute or chronic hepatitis B virus (HBV) infection. It also helps in detecting if a person has previously infected with hepatitis B infection, or sometimes to guide and monitor treatment.",
  },
  {
    id: "16",
    productName: "Total Ige",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 790,
    description:
      "IgE, one of the five subclasses of antibodies found in mammals is a key molecule in allergy responses and inflammation. When an individual is exposed to an allergen, the allergen particles bind to the sensitized mast cells bound to IgE. Mast cells secrete components of allergic reactions such as cytokines, histamines, etc. Hence a person undergoing persistent or periodic symptoms of allergy can be advised to be tested for total IgE levels. This test is also recommended when the allergen is unknown and its detection is required for effective immunotherapy/ allergen shots against specific allergies. Quantitative measurement of serum IgE with other clinical indicators can provide useful information for the differential diagnosis of Atopic and Non-Atopic diseases. For diagnostic purposes, results should always be assessed with the patient’s medical history, clinical examination, and other findings.",
  },
  {
    id: "17",
    productName: "25-Oh Vitamin D (Total)",
    imgUrl: bloodTest01,
    category: "wireless",
    type: "product",
    price: 1000,
    description:
      "The 25-OH vitamin D test is the most accurate way to measure vitamin D levels in your body. Vitamin D helps control phosphate and calcium levels in the body. Book now at an affordable rate and get a free home collection.",
  },
  {
    id: "18",
    productName: "Insulin - Fasting",
    imgUrl: bloodTest01,
    category: "product",
    price: 750,
    description:
      "A fasting insulin level test is valuable in detecting type 1 as well as type 2 diabetes. It can be done to diagnose hypoglycemia when one has insulin resistance. This test is usually recommended for people with prediabetes, diabetes, polycystic ovarian syndrome, heart diseases, metabolic syndrome, etc. Book an Insulin fasting test from Thyrocare at a very affordable price and get home collection services.",
  },
  {
    id: "19",
    productName: "Follicle Stimulating Hormone (Fsh)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 480,
    description:
      "Follicle Stimulating Hormone  (FSH) is a pivotal hormone that regulates the menstrual cycle and ovulation in women. In men, this hormone stimulates testicular growth. Measuring the levels helps to detect problems related to reproductive functions. Thyrocare offer FSH test at a low cost and along with home collection services.",
  },
  {
    id: "20",
    productName: "Ferritin",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 750,
    description:
      "Ferritin is a major protein that is the body’s storehouse of iron.  A ferritin test helps to assess disorders related to iron deficiency like anemia and iron overload. Thyrocare offers the Ferritin test at the lowest rate with the home collection service.",
  },
  {
    id: "21",
    productName: "Luteinising Hormone (Lh)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 480,
    description:
      "Luteinising Hormone plays an important role in maintaining the normal reproductive functions in both males and females. Abnormal levels are found to be associated with infertility, polycystic ovarian syndrome, menstrual problems, testicular atrophy, etc. Thyrocare offer LH test at a low cost and along with home collection services.",
  },
  {
    id: "22",
    productName: "Anti Mullerian Hormone (Amh)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1970,
    description:
      "Anti-Müllerian Hormone Test (AMH) is a marker that is used to evaluate an ovarian reserve and predict the outcome of In-vitro Fertilization (IVF) or other Assisted Reproductive Technology (ART). This test can also be used to assess the ovarian function in patients with Polycystic Ovarian Syndrome (PCOS), to diagnose and monitor Ovarian tumors, and to determine the menopausal status.  Thyrocare offers an AMH test at the lowest price with the home collection.",
  },
  {
    id: "23",
    productName: "Urinary Microalbumin",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 620,
    description:
      "This test checks the kidney functions, as in the case of normally functioning kidneys, albumins are not leaked into the urine. Hence, the presence of albumin in the urine is a marker for kidney dysfunction. Book this test from Thyrocare at a very low cost and get home collection services.",
  },
  {
    id: "24",
    productName: "Calcium",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 220,
    description:
      "Calcium plays an important role in many physiological functions of the body. Abnormal calcium levels affect bone health, muscle contraction, blood clotting, enzyme activity, neural transmission, etc., Book your calcium blood test at an affordable price with free home collection.",
  },
  {
    id: "25",
    productName: "Anti Thyroglobulin Antibody (Atg)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1080,
    description:
      "Thyroglobulin is a key protein in the thyroid gland that is essential for the synthesis of thyroxine (T4) and triiodothyronine (T3). Antithyroglobulin antibody test measures levels of antibodies to thyroglobulin. This test helps to identify autoimmune diseases involving the thyroid gland. The presence of thyroid autoantibodies causes disorders such as Hashimoto’s thyroiditis, Graves’ disease, Hypothyroidism, Thyroid cancer, etc. Women with high levels of ATG might miscarry or be infertile. While in cases of neonatal hypothyroidism, the detection of ATG in the infant suggests transplacental antibody transfer, particularly if the mother has a history of autoimmune thyroiditis or detectable thyroid autoantibodies.",
  },
  {
    id: "26",
    productName: "Anti Ccp (Accp)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1460,
    description:
      "Anti-Cyclic Citrullinated Peptide is an antibody found to be present in individuals with rheumatoid arthritis (RA). Measuring its levels helps in detecting as well as assessing the severity of RA. This test is available at an affordable price with home collection services.",
  },
  {
    id: "27",
    productName: "Testosterone",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 610,
    description:
      "The test measures the amount of testosterone hormone in the blood. Testosterone, a sex hormone, is found in both men and women (in small amounts). Abnormal levels of this hormone can cause health issues, such as sexual dysfunction, PCOS, hypogonadism and cancer. Book testosterone test at Thyrocare and get a free home sample collection.",
  },
  {
    id: "28",
    productName: "Carcino Embryonic Antigen (Cea)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 740,
    description:
      "It is produced during the development of a fetus and production stops before birth. The expression of CEA is increased in almost all types of cancers (mainly ovarian cancer) and hence used as a tumor marker.",
  },
  {
    id: "29",
    productName: "Estradiol/Oestrogen (E2)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 570,
    description:
      "Estradiol is a key type of estrogen (female sex hormone) produced by the ovaries. However, during pregnancy, the placenta also produces estradiol. This test is recommended for females to assess reproductive health, menstrual cycle, fertility, and other factors. Increased levels may be indicative of pregnancy, gynecomastia, or ovarian tumors. Levels are also high during the assisted reproduction stage where ovulation is induced and low during the early follicular phase. Whereas decreased levels may either indicate a lesion in the hypothalamus-pituitary axis or a lack of ovarian synthesis. Thyrocare offers this test at a discounted rate, along with the home collection.",
  },
  {
    id: "30",
    productName: "Free Testosterone",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1220,
    description:
      "Testosterone is a C-19 steroid secreted by the testis and adrenal cortex in men, and by ovaries in women. Hypogonadism in males and hyperandrogenic states in females can be clinically evaluated with testosterone measurements. Testosterone circulates in the blood bound to three proteins, i.e. sex hormone-binding globulin (60-80%), albumin and cortisol binding globulin. Unbound or free testosterone accounts for only about 1-2% of the total circulating testosterone. Along with diagnosing infertility and PCOD in females, diseases/ damages of ovaries, testes, adrenal and pituitary gland can also be screened using this test. Free Testosterone test is available at the most reasonable price with home collection services.",
  },
  {
    id: "31",
    productName: "Cortisol",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 700,
    description:
      "The secretion of Cortisol is controlled by the pituitary gland and levels are often measured to evaluate the pituitary function and/or adrenal function. Abnormalities of Cortisol secretion can result in diseases either in the pituitary gland or the adrenals. Overactivity of either organ can lead to over secretion of cortisol, and cause Cushing's syndrome. Book Cortisol test from Thyrocare at a low cost and get home collection facility.",
  },
  {
    id: "32",
    productName: "Rubella - Igg",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 410,
    description:
      "The presence of RUBELLA - IgG antibodies is evidence of past infection or immunization. The presence of specific IgG on testing indicates immunity to rubella. Negative IgG results indicate the susceptibility of the patient to infection. Book this test from Thyrocare at a very low cost and get home collection services.",
  },
  {
    id: "33",
    productName: "Lactate Dehydrogenase (Ldh)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 340,
    description:
      "Lactate dehydrogenase (LDH) is an enzyme present extensively in body tissues, such as blood cells, skeletal muscles, kidneys, brain, and lungs. The tissue levels of this enzyme are 500 fold higher than those normally present in the serum. Thus any cells or tissue damage elevates the serum level of LDH to a significant extent. Thus, increased LDH level in blood is generally an indication of cellular damage. Thyrocare offers an affordable Lactate Dehydrogenase (LDH) test with the free home collection.",
  },
  {
    id: "34",
    productName: "Anti Microsomal Antibody (Ama)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1140,
    description:
      "The presence of antimicrosomal antibodies (AMA) is generally associated with autoimmune disorder. Detection of these antibodies can assist in identifying damage to the thyroid cells causing such disorders. Book AMA blood test online at an affordable price, with a free home collection from Thyrocare.",
  },
  {
    id: "35",
    productName: "Anti Nuclear Antibodies (Ana)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 750,
    description:
      "ANAs are a special class of autoantibodies that bind and destroy certain parts in the nucleus of the cell. Although a little amount of ANA is found in the normal population, an increased level is normally observed in people with connective tissue disease (CTD). Book ANA test at an affordable price, with a free home collection from Thyrocare.",
  },
  {
    id: "36",
    productName: "Ca-125",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1270,
    description:
      "CA125 is an ovarian cancer antigen. Certain cancers such as those of the breast, gastrointestinal tract, and kidney also show elevated levels of CA125. Thus, it is a sensitive but non-specific tumor marker that is used in the detection and monitoring of ovarian cancer. Book now to avail services at your doorstep, at very affordable rates.",
  },
  {
    id: "37",
    productName: "D-Dimer",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1240,
    description:
      "D-dimers are small fragments of proteins detected in the blood after breaking down a blood clot. D-dimer levels are used to detect these blood clots. D-dimer test is used in diagnosing blood clots deep inside the veins, to check for blockage in the arteries and lungs, which can affect the blood flow to various organs and tissues as well as increase the chances of a Heart attack. D-dimer test is recommended for someone with chest pain, increased heart rate, difficulty in breathing, seizures, blood in cough, bleeding gums, nausea, decreased urination, muscle pain, leg pain, and swelling. Elevated levels of D-dimer protein are seen in severely infected COVID19 patients, and hence it is used as a marker to predict the severity of the disease. Elevated D-dimer levels are also noted in older ages, pregnancy, liver and kidney diseases. Thyrocare offers the Dimer test at the most affordable price. Sample collection at home available.",
  },
  {
    id: "38",
    productName: "Phosphorous",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 220,
    description:
      "It is an important element necessary to maintain bones, teeth, nerve signaling, muscle contraction, energy storage  and many others. High levels are seen to be associated with kidney, liver and bone diseases.",
  },
  {
    id: "39",
    productName: "Vdrl (Rpr) For Syphilis",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
    description:
      "The Venereal Disease Research Laboratory (VDRL) test is used to diagnose Syphilis, a sexually transmitted infection (STI) caused by a spirochete Treponema pallidum. This test detects antibodies generated by your body in response to antigens produced by bacteria-damaged cells. Syphilis can cause long-term complications by invading the nervous and cardiovascular system, if not treated properly. It may also be transmitted from infected mother to child during pregnancy or at birth, resulting in congenital Syphilis. Book Thyrocare's VDRL test at a low cost with the home collection.",
  },
  {
    id: "40",
    productName: "Hla-B27",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 2090,
    description:
      "Human Leukocyte antigen B27 (HLA- B27) belongs to a group of cell surface glycoproteins which are expressed on most nucleated human cells and platelets. It is a major histocompatibility complex (MHC) class I molecule. The presence of HLA - B27 is strongly associated with ankylosing spondylitis and some inflammatory disorders like Reiter’s syndrome, inflammatory bowel syndrome, etc. The binding ability of specific monoclonal antibodies to the antigenic determinants expressed by leucocytes on the surface forms the basis of this test. HLA-B 27 test is generally advised in patients suffering from joint pain where the diagnosis of ankylosing spondylitis is suspected. A positive test result indicates higher chances of developing this disease. Avail of the service by booking the HLA-B27 test online at an affordable rate, at your doorstep.",
  },
  {
    id: "41",
    productName: "Magnesium",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 410,
    description:
      "Magnesium is the mineral found in the body that is needed for healthy bones, heart, muscles, and nerves. This test evaluates the level of magnesium as its deficiency can cause cardiac arrhythmia, muscle cramps, or tremors. Book a Magnesium test from Thyrocare at a low cost and get a home collection facility.",
  },
  {
    id: "42",
    productName: "Rubella - Igm",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
    description:
      "Rubella is a viral infection generally characterized by a rash. Respiratory aerosols are a major source through which virus is transmitted from person to person. The first clinical manifestation of rubella is usually the appearance of a macro-papular rash some 16-20 days after exposure. The rash, appearing first on the face, spreads further over the trunk and the extremities. The presence of RUBELLA - IgM antibodies in blood indicates recent or current infection with the Rubella virus. In rare cases, IgM antibodies are known to persist for years following a previous infection and also immunization.",
  },
  {
    id: "43",
    productName: "High Sensitivity C-Reactive Protein (Hs-Crp)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 450,
    description:
      "High Sensitivity C-Reactive Protein (Hs-CRP) is an acute-phase protein that is synthesized in the liver. Its concentration increases after exposure to inflammation. This test is used to determine the risk of developing coronary artery disease as CRP is considered to be a cardiac risk marker. Book Thyrocare's hs-CRP test at a low cost with the home collection.",
  },
  {
    id: "44",
    productName: "Urine Culture And Susceptibility",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 840,
  },
  {
    id: "45",
    productName: "Nt-Probnp",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1850,
  },
  {
    id: "46",
    productName: "Adult Hemoglobin Electrophoresis",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1090,
    description:
      "It is a blood test that measures and the identifies different types of hemoglobin. Presence of any abnormal hemoglobin types can be detected to manage or treat the same, as abnormal hemoglobin type may impair the amount of oxygen transported to the cells of the body.",
  },
  {
    id: "47",
    productName: "Alkaline Phosphatase",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
  },
  {
    id: "48",
    productName: "Sodium",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 220,
    description:
      "This test is used to detect abnormal concentrations of sodium, termed hyponatremia (low sodium) and hypernatremia (high sodium). While low levels can cause confusion, headache, seizure, high levels leads to high blood pressure, heart and kidney problems.",
  },
  {
    id: "49",
    productName: "C-Peptide",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1070,
    description:
      "C-Peptide is a protein released into the blood during the process of insulin production by the pancreas. C-peptide Test test can say how well your body makes insulin. It can also help to differentiate between Type-1 and Type-2 diabetes. Book a C-peptide test from Thyrocare and get services at your doorstep in very affordable rates.",
  },
  {
    id: "50",
    productName: "Ca 19.9",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1220,
    description:
      "CA 19-9 is a tumor-associated antigen that is elevated mostly in patients with Advanced Pancreatic Cancer. It may also be elevated in other cancers, conditions, diseases such as colorectal cancer, lung cancer, gall bladder cancer, gallstones, pancreatitis, cystic fibrosis, and liver disease. Although, increase in the levels of CA 19-9 is not distinctively suggestive of pancreatic cancer, currently, it is the single most useful blood test to differentiate benign disorders from malignant ones. Book a CA 19-9 test from Thyrocare at an affordable cost and get home collection services.",
  },
  {
    id: "51",
    productName: "Amylase",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 520,
    description:
      "Amylase catalyzes the breakdown of complex starch. Most of the serum amylases are mainly derived from the pancreas and pituitary gland. The measurement of alpha-Amylase is important for the diagnosis of pancreatitis (inflammation of the pancreas) as well as other pancreatic and intestinal diseases.",
  },
  {
    id: "52",
    productName: "Lipase",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 610,
    description:
      "Lipase is an enzyme produced by the pancreas to digest dietary fats. It is usually present in very small quantities, but when the pancreatic cells are injured, a higher concentration of lipase is released in the blood. A blood test for lipase is usually used to diagnose and monitor disorders related to the pancreas. The level of lipase in the blood can predict conditions like inflammation of the pancreas, blockage of the pancreatic duct by a gallstone, and pancreatic tumor. A lipase test is recommended for a person with symptoms of a pancreatic disorder, such as severe abdominal or back pain, fever, loss of appetite with jaundice, and rapid pulse rate. Book a Lipase test from Thyrocare at a low cost and get home collection services.",
  },
  {
    id: "53",
    productName: "Serum Zinc",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 410,
    description:
      "Zinc is one of the essential trace elements, is present throughout the body in many tissues but is not stored at any particular site. Zinc deficiency can occur where zinc needs exceed the intake or in case of malabsorption. Alcoholism, pregnancy & burns are often associated with zinc deficiency. Zinc levels decrease in response to infections, so a low result may not necessarily mean a person is zinc deficient. Clinically, Zinc deficiency leads to hair loss, poor wound healing, dermatitis, and impaired immune function. In children, it can cause growth retardation. Since zinc can be excreted in the urine/feces, high levels are rarely seen. Excessive supplementation of Zinc leads to toxicity. Serum zinc test is available at affordable cost, with a free home collection.",
  },
  {
    id: "54",
    productName: "Glucose-6-Phosphate Dehydrogenase",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 700,
    description:
      "Glucose-6-Phosphate Dehydrogenase (G6PD) enzyme is active in almost all types of cells, and is involved in the processing of carbohydrates and energy production. It plays a critical role in red blood cells (RBCs) by protecting them from damage and premature destruction. G6PD deficiency is an inherited, sex-linked, metabolic disorder, which is characterized by a defect in an enzyme that leads to the breakdown of RBCs (hemolysis) upon exposure to stress resulting from certain microbial infections or certain drugs. G6PD deficiency may lead to acute hemolytic anemia. Thyrocare offers this test at a discounted price, along with a free home collection facility.",
  },
  {
    id: "55",
    productName: "Alpha Feto Protein (Afp)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 760,
    description:
      "AFP is produced in the liver of a developing baby and protects it against the maternal immune system. Abnormal levels of embryonic AFP in the mother's serum can be indicative of birth defects like spina bifida or genetic abnormalities like Down's syndrome in the baby. Thyrocare offers this test at a discounted rate, along with the home collection.",
  },
  {
    id: "56",
    productName: "Tissue Transglutaminase - Iga (Ttg)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1220,
    description:
      "Tissue Transglutaminase  (tTG) is an enzyme responsible for protection, prevention, and tissue remodeling or repair processes. Anti-tTG antibodies are more sensitive and specific than anti-Gliadin antibodies. Screening for tTG-IgA antibodies is recommended to identify patients at risk for celiac disease. This test detects autoantibodies in the blood that the body produces as part of the immune response. It also aids in monitoring adherence to a gluten-free diet in disease confirmed patients.",
  },
  {
    id: "57",
    productName: "Progesterone",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 580,
    description:
      "Progesterone is an endogenous steroid hormone that aids in the implantation of the fertilized egg in the uterus. It is produced by the adrenal cortex as well as ovaries and testes. It is also secreted by the corpus luteum and the placenta and is responsible for preparing the body for pregnancy and, if pregnancy occurs, maintaining it until birth. Estimating progesterone levels is important in assessing the probability and risk of ectopic pregnancy, determining the cause of infertility, and diagnosing abnormal uterine bleeding. Low levels of progesterone are a marker of incipient pre-eclampsia/toxemia in a pregnant woman. Avail of the home collection services for this test at an affordable cost.",
  },
  {
    id: "58",
    productName: "Anti Streptolysin - O (Aso)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 620,
    description:
      "Antistreptolysin O (ASO) test determines antibodies in the blood against streptolysin O, an enzyme produced by group A streptococcus bacteria. This is also helpful in checking whether the certain condition or disease is due to a recent streptococcal infection. Anti-Streptolysin O test is now available at an affordable cost, with the free home collection.",
  },
  {
    id: "59",
    productName: "Ca 15.3",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 770,
    description:
      "Cancer antigen 15-3 (CA 15-3), a protein produced by normal breast cells, is used as a biomarker to monitor cancerous breast tumors. It helps in determining the effectiveness of treatment and disease recurrence. Normal levels of CA 15-3 protein are produced by breast cells, however, increased production is observed in the case of breast cancer. CA 15-3 levels are also elevated in individuals with other cancers or diseases, such as colorectal cancer, lung cancer, cirrhosis, Hepatitis, and Benign Breast Disease. Thyrocare offers this test at a discounted price, along with a free home collection facility.",
  },
  {
    id: "60",
    productName: "Potassium",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 220,
    description:
      "It is essential for proper muscle and nerve functioning. Changes in its levels may cause severe health issues, hence levels need to be assessed.",
  },
  {
    id: "61",
    productName: "Procalcitonin",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1300,
    description:
      "Procalcitonin is a peptide precursor of the hormone calcitonin, which regulates and maintains calcium equilibrium in the body. It is produced naturally in the body and serves as a marker for septic infection. This test determines the level of procalcitonin in blood and aids in the early detection of severe bacterial infections. Pro-inflammatory stimuli during bacterial infection, sepsis during operation/trauma lead to an increase in circulating procalcitonin levels beyond the normal range. Now free sample collection at your home with discounted costs.",
  },
  {
    id: "62",
    productName: "Creatinine - Serum",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 200,
    description:
      "Creatinine is produced as a result of normal muscle metabolism. It is measured to estimate the efficiency of the glomeruli of the kidneys to remove waste products from the blood and thus,indicate the overall kidney health.",
  },
  {
    id: "63",
    productName: "Intact Parathyroid Hormone (Pth)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1220,
  },
  {
    id: "64",
    productName: "Aldosterone",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1500,
  },
  {
    id: "65",
    productName: "Prothrombin Time",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 400,
  },
  {
    id: "66",
    productName: "Creatinine Phosphokinase",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 330,
  },
  {
    id: "67",
    productName: "Dengue-Igm",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 299,
  },
  {
    id: "68",
    productName: "Iron",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
    description:
      "As iron has the ability to accept and donate electrons, it is required for a variety of normal cellular functions. Iron is also vital for proper growth and development, and deficiencies can cause anemia and related health conditions.",
  },
  {
    id: "69",
    productName: "Total Iron Binding Capacity (Tibc)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 340,
    description:
      "Transferrin is a glycoprotein that transports iron throughout the body. This test measures the amount of transferrin to assess the body's ability for iron transportation, in order to diagnose iron deficinecy or high levels of iron.",
  },
  {
    id: "70",
    productName: "Dengue Ns1 Antigen",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 299,
  },
  {
    id: "71",
    productName: "Ana Screening (Immunofluorescence)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 750,
  },
  {
    id: "72",
    productName: "Dengue-Igg",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 299,
  },
  {
    id: "73",
    productName: "Valproic Acid",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 520,
    description:
      "Valproic acid is used as an anticonvulsant drug in treating epileptic seizures, often in combination with other drugs. It is also used as a mood-stabilizer, in cases of children with aggressive behavioral patterns and attention deficit hyperactivity disorder (ADHD). It is also approved in the treatment of migraines, bipolar disorder, and schizophrenia. It also gives promising results in the treatment of certain solid tumors, colonic cancers, medulloblastomas, follicular thyroid cancer, leukemias, and as a part of the multidrug regimen used in Alzheimer’s disease. The valproic acid test is available at a discounted price, along with a home collection.",
  },
  {
    id: "74",
    productName: "Homocysteine",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1130,
    description:
      "An amino acid, whose elevated levels in the bloodstream is related to increased risk of blood clot formation, atherosclerosis, heart attack and stroke. Increased levels are also associated with homocystinuria, an inherited condition.",
  },
  {
    id: "75",
    productName: "Covid Antibody Igg (Quantitative)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 500,
    description:
      "COVID Antibody test is used to recognize individuals with adaptive immune response against SARS-CoV-2, which indicates a recent or prior infection. Generally, IgG antibodies start to develop after 2 weeks from the onset or after recovering from an infection.",
  },
  {
    id: "76",
    productName: "Alpha-1-Antitrypsin (Aat)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1240,
    description:
      "Alpha-1-antitrypsin (AAT) is a protein produced by the liver that protects our lungs from damage caused by Neutrophil elastase. In case of abnormal AAT or non-functional AAT, neutrophil elastase destroys alveoli in the lungs, resulting in lung disease. The alpha-1-antitrypsin test determines the level of alpha-1-antitrypsin in blood. This test is recommended by a physician if the patient is under the age of 45 and has symptoms such as wheezing, coughing, shortness of breath, or asthma, or if they have a family history of the disorder or conditions like Chronic Obstructive Pulmonary Disease (COPD) or liver disease with unknown cause. ATT deficiency can lead to complications of the lungs, liver, and skin. Reduced ATT levels increase the risk of COPD, emphysema, chronic bronchitis, and liver cirrhosis. AAT levels rise in acute and chronic inflammatory conditions, infections, and hepatocellular carcinoma. ATT levels also increase during oral contraceptive therapy and pregnancy.",
  },
  {
    id: "77",
    productName: "Anti Hepatitis A Virus (Anti Hav) - Igm",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1030,
    description:
      "Anti-HAV test is primarily used to determine the cause of acute hepatitis or to identify the type of hepatitis virus causing an infection. Individuals produce IgM antibodies on exposure to HAV either naturally or due to vaccination. Testing for the presence of IgM antibodies against the hepatitis A virus is performed when the patient shows symptoms of hepatitis such as fever, fatigue, nausea, vomiting, abdominal pain, dark urine and/or pale-colored stool, joint pain, jaundice. The serological detection of HAV antibodies is an important marker for confirming HAV infection, classification of the virus, and determining the source of infection. Book this test and get Free Sample Collection at Home at an affordable price.",
  },
  {
    id: "78",
    productName: "Total Thyroxine (T4)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
    description:
      "T4 is a hormone secreted by the thyroid gland that plays a role in the body's vital functions, thus needs to be monitored. This test singly or in combination with T3 and TSH is used to identify thyroid disorders.",
  },
  {
    id: "79",
    productName: "Cystatin C",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 520,
    description:
      "Cystatin C is a small protein found in body fluids like blood. It is filtered by the glomeruli (tiny blood vessels) present in the kidney affecting its blood concentration and is evaluated by measuring the glomerular filtration rate (GFR) is the rate at which kidneys filter the fluid). It assesses the functioning of the kidneys. Avail of the home collection services for this test at an affordable cost.",
  },
  {
    id: "80",
    productName: "Total Triiodothyronine (T3)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 200,
    description:
      "It is a hormone secreted by the thyroid gland and, any variations in its level can have an effect on thyroid functions. Monitoring the levels of T3, therefore, becomes a crucial parameter to detect thyroid disorders.",
  },
  {
    id: "81",
    productName: "Free Psa",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1220,
    description:
      "Prostate-Specific Antigen (PSA), is a glycoprotein produced by cells of the prostate that remains free in the blood. Free PSA test measures the amount of unbound prostate-specific antigen in the blood, which helps physicians to identify problems such as prostate inflammation or tumor. Levels of PSA rise in conditions such as prostate cancer and also in benign prostatic hyperplasia (BPH).",
  },
  {
    id: "82",
    productName: "Anti - Dsdna",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 760,
    description:
      "Anti-dsDNA test looks for anti-double-stranded DNA antibodies which are autoantibodies to double-stranded DNA. Anti-dsDNA antibodies are characteristic of autoimmune disorders such as Systemic Lupus Erythematosus (SLE). The levels of these antibodies fluctuate with disease activity. Anti-ds-DNA antibody titers may decrease with immunosuppressive therapy and when the disease is in remission. Anti-ds-DNA antibody testing is used to help the diagnosis of SLE, distinguish it from other autoimmune conditions, and assist in disease surveillance. Increase in the level of Anti ds-DNA antibody can be a prior indicator of flare-ups in which their symptoms intensify and then subside.",
  },
  {
    id: "83",
    productName: "Anti Hepatitis E Virus (Anti Hev) - Igm",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1320,
    description:
      "HEV is often transmitted through contaminated water and affects the liver. Anti HEV-IgM is the antibodies that are produced in exposure with HEV by the body. The presence of these antibodies serves as a marker of acute HEV infection. Take the benefit of free home collection at a much affordable price just by booking the test from Thyrocare. ",
  },
  {
    id: "84",
    productName: "Dhea - Sulphate (Dheas)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 760,
    description:
      "Dehydroepiandrosterone sulfate (DHEA-S) is a steroid hormone, which plays animportant role in the development of secondary sexual characteristics during puberty. Although an androgen (male sex hormone), is present in both males and females. Secretion of DHEA-S is controlled by the adrenocorticotropic hormone produced by the pituitary gland. This test measures the levels of DHEA-S in your blood. Excess production of DHEA-S results in precocious puberty in boys and excess body hair, abnormal menstrual cycle, and ambiguous external genitalia in girls. DHEA-S may be used in the differential diagnosis of Cushing’s syndrome. DHEA-S may also be used in the evaluation of adrenocortical diseases, such as congenital adrenal hyperplasia and adrenal tumors. Take the benefit of free home collection at a much affordable price",
  },
  {
    id: "85",
    productName: "Toxo Gondii - Igm",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
    description:
      "Toxoplasma gondii is an intracellular parasitic protozoan that causes Toxoplasmosis. Infection is typically caused by eating contaminated undercooked meat, coming into contact with infected cat feces, or mother-to-child transmission during pregnancy. Most people with the disease have no symptoms, but it can cause serious complications in infants born to infected mothers and immunocompromised people. Toxo Gondii - IgG tests for the presence of IgG antibodies against Toxoplasma gondii and determines whether an individual has previously been infected with the disease. The absence of IgG antibodies before or early in pregnancy identifies women at risk of infection, while the presence of IgG identifies immunocompromised patients at risk of reactivation of a latent infection. Book this test and get free home collection services at a much-discounted price.",
  },
  {
    id: "86",
    productName: "Folate",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 770,
    description:
      "Folate ( vitamin B9), along with vitamin B12, checks for malnutrition and anemic conditions if any. Folate, crucial for the normal development of a fetus, is also vital for maintaining overall health making it critical for pregnant women. Book Folate Test at affordable Price with free home collection services.",
  },
  {
    id: "87",
    productName: "Herpes Simplex Virus I (Hsv)-Igm",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
    description:
      "Herpes simplex virus (HSV) is a member of the Herpesviridae family, of which two types are known: type 1 (HSV-1) and type-2 (HSV-2) which present slight antigenic differences. The assay of specific IgG is important to establish the serological state of the patient, diagnosis of neonatal infection and encephalitis caused by HSV. Moreover, the presence of specific IgG indicates viral activity in progress, although it is not possible to distinguish between primary infection and reactivation.",
  },
  {
    id: "88",
    productName: "Insulin - Pp",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 530,
    description:
      "A Postprandial insulin test measures the insulin levels in the blood after two hours of food consumption. This test assesses whether an adequate amount of insulin is produced by the pancreas to maintain the blood glucose levels post-meal.",
  },
  {
    id: "89",
    productName: "Serum Copper",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
    description:
      "Copper is an important trace element in the blood and a component of numerous enzymes and proteins involved in energy production, connective tissue formation, melanin synthesis, iron metabolism, development of central nervous system, formation of new blood vessels (angiogenesis) and antioxidants. Serum Copper test measures the amount of copper present in your blood, thereby aiding in diagnosis of various conditions related to copper deficiency or toxicity. Elevated levels of serum copper can lead to excess deposition of copper in various organs including liver and brain which can directly or indirectly lead to many disorders like Wilson’s disease, Acute renal failure, and Chronic liver disease. Whereas insufficient levels can lead to malnourishment, cardiovascular disease, anemia & neuropathy. Copper levels may also be checked to monitor preterm newborns on nutritional supplementation.",
  },
  {
    id: "90",
    productName: "Fructosamine",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
    description:
      "When glucose combines with protein, it forms a compound called Fructosamine. This test measures the total amount of fructosamine of glycated protein in the blood. The test aids in screening Diabetes Mellitus and Gestational Diabetes Mellitus. It is useful in monitoring the control of glucose levels over the past two to three weeks. Increased levels of fructosamine indicate poor glucose control. Book this test and get free home collection services at a much discounted price.",
  },
  {
    id: "91",
    productName: "Herpes Simplex Virus (Hsv)-Igg",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
    description:
      "Thyrocare has an IT-enabled, 24*7, fully automated diagnostic laboratory set up spanning over 200,000 sq. ft. area for conducting error-free processing of 100,000+ specimens and 400,000+ clinical chemistry investigations per night. A combination of air-cargo logistics and IT-enabled barcoded bi-directional operating systems ensure quick turnaround time for processing of samples that arrive at any time of the day or night from various parts of the country and help achieve this unmatched speed factor.",
  },
  {
    id: "92",
    productName: "Lp-Pla2",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1030,
    description:
      "Lp-PLA2 (Lipoprotein-Associated Phospholipase A2) is a vascular-specific enzyme produced by inflammatory cells. It is involved in the formation of plaque (wax made of fats and cholesterol) around the walls of arteries, which if ruptured may lead to a heart attack. Thus, individuals with increased levels of Lp-PLA2 enzyme are at higher risk of cardiovascular disorders and stroke. Some studies indicate that the Lp-PLA2 test is a better marker for detecting a heart-related disease than high-density lipoprotein (HDL) and low-density lipoprotein (LDL) levels. Now free sample collection at your home with discounted costs",
  },
  {
    id: "93",
    productName: "Blood Ketone (D3hb)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
    description:
      "Ketones are chemicals that are produced by the body if cells do not get enough glucose. This test, which determines the level of ketones in the blood. Elevated ketone levels are also seen if a person is fasting, exercising, or consuming more dietary fats than usual or is on diet with restricted calories. High ketone levels may indicate a life-threatening complication of Diabetic Ketoacidosis (DKA), in which the blood becomes too acidic. Book Thyrocare's blood ketone Test at an inexpensive cost with the free home collection.",
  },
  {
    id: "94",
    productName: "Erythropoietin",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 770,
    description:
      "Erythropoietin (EPO), a glycoprotein hormone, is produced by the kidney and in small amounts, by the liver. EPO is a primary regulator of erythropoiesis and plays a major role to protect RBC from destruction. EPO test helps to diagnose various conditions such as anemia and polycythemia. This assay also aids in the prediction and monitoring of response to recombinant EPO treatment in people with anemia. Patients affected with secondary polycythemia (a condition in which a number of RBC increases) has elevated EPO level. Whereas deficiency of EPO is seen in chronic kidney failure, chronic anemia, or polycythemia vera. Book this test and get Free Sample Collection at Home at an affordable price.",
  },
  {
    id: "95",
    productName: "Apolipoprotein - B (Apo-B)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 570,
    description:
      "Apolipoprotein A1 (APO-A1) is the primary protein associated with HDL cholesterol. Increased levels mostly indicate a reduced risk of cardiovascular diseases. Estimation on APO-A1 is needed for monitoring the cardiac risk of subjects with a family history of CVD’s and also evaluating the effectiveness of lipid-lowering therapy. Book your Alipoprotein - B (APO-B) home test for evaluating heart health at an affordable price",
  },
  {
    id: "96",
    productName: "Lipoprotein (A) [Lp(A)]",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 480,
    description:
      "Estimation on lipoprotein A is needed for monitoring the cardiac risk of subjects with a family history of cardiovascular disease (CVD) and also evaluating the effectiveness of lipid-lowering therapy. Increased levels mostly indicate a reduced risk of cardiovascular diseases. Book your lipoprotein home test for evaluating heart health at an affordable price",
  },
  {
    id: "97",
    productName: "Androstenedione (A4)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 770,
    description:
      "Androstenedione is a steroid hormone secreted by the adrenal glands, ovaries and testicles. It is responsible for the onset of sexual differentiation in males and development of male secondary sexual characteristics after the onset of puberty, including, deepening of voice, growth of facial hair, etc. Excess of androstenedione may result in ambiguous external genitalia (infants external genitals do not appear to be clearly either male or female), hirsutism (abnormal growth of facial hair in females), abnormal menstrual cycles in girls and precocious puberty (puberty before age of 9) in boys. Elevated levels are associated with adrenal cancer, some ovarian and testicular tumors, adrenocortical tumors and congenital adrenal hyperplasia.",
  },
  {
    id: "98",
    productName: "Immunoglobulin A (Iga)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 770,
    description:
      "The Immunoglobulin A or IgA test is used to assess the levels of IgA antibodies in the blood. This test aids in screening of autoimmune disorders and cancers, however, the test cannot pinpoint the exact cause of the IgA level fluctuations and correlation with other tests is necessary to find out the root cause for fluctuations in IgA levels. Book IgA test from Thyrocare at a low cost with a home collection facility.",
  },
  {
    id: "99",
    productName: "Immunoglobulin M (Igm)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 770,
    description:
      "The Immunoglobulin M test measures the level of IgM antibodies in the blood. This test is used to assess the immune system status of the person and its ability to deal with antigens. Book IgM test from Thyrocare at a low cost with a home collection facility.",
  },
  {
    id: "100",
    productName: "Phenytoin / Dilantin / Eptoin",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 520,
    description:
      "Phenytoin test offered by Thyrocare aids in monitoring blood Phenytoin concentration and determine if the drug level is within the therapeutic range. Individuals are advised to take up the Phenytoin test every few days after starting phenytoin medication. Routine monitoring of serum phenytoin concentrations is necessary to maintain therapeutic efficacy and avoid toxicity. Phenytoin test may also aid in determining renal failure. Results should often be evaluated in conjunction with the time of blood collection, dosage, and other medical histories.",
  },
  {
    id: "101",
    productName: "Cardiolipin Antibody (Acl) - Iga",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 520,
    description:
      "Cardiolipin is a phospholipid of outermost layer of cells (cell membranes), mitochondrial membranes and platelets. Cardiolipins play a key role in the process of blood clotting. Anti-cardiolipin antibodies are acquired auto-antibodies produced against cardiolipins and are found in the immunoglobulin classes- IgG, IgM and/or IgA. The presence of anti-cardiolipin antibodies in systemic lupus erythematosus can be related to the development of thrombosis. Anti-cardiolipin antibodies have been found in some cerebrovascular insufficiency, cerebral ischemia and in myocardial infarction. Moreover, this anticardiolipin test also assists in the diagnosis of antiphospholipid syndrome. This diagnosis has significant implications for treatment and prediction of recurrent thrombosis and recurrent miscarriage.",
  },
  {
    id: "102",
    productName: "Chikungunya-Igm",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 520,
    description:
      "Chikungunya virus is transmitted to humans by infected Aedes mosquitoes. Infected patients typically have a sudden onset high fever, incapacitating joint pain, muscle pain, headache, exhaustion, and a maculopapular rash that lasts 3 to 10 days. Chikungunya IgM test measures levels of IgM antibody against the Chikungunya virus and helps in the diagnosis of chikungunya infection during the acute phase of the disease (more than 5 days after symptom onset). Since the clinical signs and symptoms of this infection are similar to those of many other infectious diseases, including Dengue fever, doctors suggest using specific laboratory testing techniques to confirm the infection. The presence of Chikungunya IgM indicates a current or recent infection. Book Thyrocare's Chikungunya - IgM Test at an inexpensive cost with the free home collection.",
  },
  {
    id: "103",
    productName: "Sex Hormone Binding Globulin (Shbg)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1030,
    description:
      "Sex hormone-binding globulin (SHBG) produced by the liver helps to transport biologically inactive forms of hormones such as testosterone, estradiol, and dihydrotestosterone into the bloodstream. Changes in its levels may have an effect on the amount of hormone available to the body. SHBG test is used for the evaluation of androgen deficiency or excess. Increased SHBG may be associated with liver disease, hyperthyroidism, hormone replacement therapy, oral contraceptives, and fertility issue. Deficiency is observed in metabolic syndrome, polycystic ovary syndrome, hypothyroidism, and Cushing syndrome.",
  },
  {
    id: "104",
    productName: "Ceruloplasmin",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 770,
    description:
      "Ceruloplasmin (CER) is the main transport protein for copper in the blood and plays a role in the body's iron metabolism. Measuring levels of ceruloplasmin aids in the diagnosis of copper metabolism disorders. Various factors such as diet, hormone concentrations, and other genetic disorders, may influence plasma concentrations. Physical exercise, pregnancy (late), bile duct obstruction, primary biliary cirrhosis, patients on estrogen therapy, and leukemia exhibit increased levels of ceruloplasmin. Decreased levels are seen in Wilson’s disease, Menkes’s disease, Acute viral hepatitis, Nephrotic syndrome, gastroenteropathies, severe liver disease, malnutrition, and hypochromic anemia. Book Ceruloplasmin test from Thyrocare at a low cost and get home collection services.",
  },
  {
    id: "105",
    productName: "Anti Hepatitis B Core Antigen (Ahbc) - Total",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 670,
    description:
      "Presence of HBcAg (core Antigen) in the cytoplasm and nucleus may reflect disease activity and predict response to antiviral treatment. Anti HBc IgM appears shortly after HBV infection and can be detected in serum soon after the appearance of circulating HBsAg and HBeAg. The levels are high during acute infection and typically disappear within 6 months, though it can persist in some cases of chronic hepatitis. Anti-HBc (IgG antibody) usually remains detectable for a lifetime.Hepatitis B Core antigen test is used to detect hepatitis B virus (HBV) infection in an individual. This test also helps to assess the risk of re-infection/reactivation. Anti-HBc is the only serological marker that can detect HBV infection and potentially infectious blood. This test cannot differentiate between acute, chronic, and resolved HBV infection.",
  },
  {
    id: "106",
    productName: "Allergy Panel - Non-Veg",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1240,
    description:
      "The Allergy Panel - Non-Veg is designed to identify specific allergens in non- vegetarian foods, such as beef, fish, prawns, chicken, mutton, shrimp, crab and pork. For individuals experiencing symptoms like skin rashes, digestive issues or respiratory problems after consuming non-vegetarian foods, this panel offers detailed reports to guide your food choices and plan your diet efficiently. Online booking is available at affordable prices. FREE home sample collection. ",
  },
  {
    id: "107",
    productName: "Allergy Panel - Inhalant",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1580,
    description:
      "The Allergy Panel - Inhalant Test identifies specific airborne or contact allergens and pollutants in the environment that your body may be allergic to. With 79 parameters, this test can detect sensitivities to various inhaled substances that may cause reactions, such as a runny nose, sneezing, red eyes, swelling around the mouth, breathing difficulties, allergic bronchitis, skin rashes, fever and even potentially life-threatening complications. Book an Allergy Panel - Inhalant test to understand your respiratory related conditions better. Get a FREE home sample collection.",
  },
  {
    id: "108",
    productName: "Allergy Panel - Drug",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 2060,
    description:
      "The Allergy Panel - Drug Test screens for potential allergic reactions to various medications. It identifies specific drugs that may trigger an allergic response, helping to ensure safe and effective treatment options. This test provides a detailed list of medications that should be avoided to prevent adverse reactions. Book an Allergy Panel - Drug test at affordable rates and get a FREE home sample collection.",
  },
  {
    id: "109",
    productName: "Allergy Panel - Food Plus Non-Veg",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3290,
    description:
      "Allergy Panel - Food Plus Non-Veg is a comprehensive test that helps identify specific allergens that may trigger allergic responses in your body. This panel tests for a wide range of allergens, including common veg and non-veg foods. Understanding your allergy triggers can help in managing symptoms and avoiding allergens effectively. Online booking is available at affordable prices. FREE home sample collection. ",
  },
  {
    id: "110",
    productName: "Allergy Panel - Food Plus Drug",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3920,
    description:
      "Food Allergy is an immune response to a particular food or body's reaction to a particular medicine. Allergy Panel - Food Plus Drug test helps one know about foods and drugs they may be allergic to that may trigger unusual bodily reactions. It identifies specific food and drug allergens and provides details about the comprehensive list of foods and drugs to be avoided. Lab visits and FREE Home collection. Book now ! ",
  },
  {
    id: "111",
    productName: "Covid Antibody Igg (QUANTITATIVE)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 410,
    description:
      "COVID Antibody test is used to recognize individuals with adaptive immune response against SARS-CoV-2, which indicates a recent or prior infection. Generally, IgG antibodies start to develop after 2 weeks from the onset or after recovering from an infection.",
  },
  {
    id: "112",
    productName: "Allergy Panel - Food Plus Inhalant",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 2510,
    description:
      "Allergy Panel - Food Plus Inhalant is a comprehensive test that helps identify specific allergens in the food or environment that may trigger allergic responses in your body. This panel tests for a wide range of allergens, including common foods and inhalants like pollen and dust. If you experience unexplained allergic symptoms such as rashes, hives, breathing difficulties and gastrointestinal issues, or have had adverse reactions to certain foods, environmental factors or medications. Book now to Understand your allergy, manage symptoms and avoid allergens effectively. FREE Home collection.",
  },
  {
    id: "113",
    productName: "Allergy Panel - Food, Inhalant Plus Non-Veg",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3450,
    description:
      "Allergy Panel - Food, Inhalant Plus Non-Veg checks for allergic reactions to various foods, inhalants and non-veg items. This test helps identify specific allergens and helps with timely management and treatment. It provides details about the comprehensive list of foods to be avoided. Book an Allergy Panel - Food, Inhalant Plus Non-Veg to understand your body's allergy pattern and manage your food intake effectively. Get a FREE home sample collection. ",
  },
  {
    id: "114",
    productName: "Allergy Panel - Food, Inhalant Plus Drug",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 4230,
    description:
      "Allergy Panel - Food, Inhalant Plus Drug is a comprehensive test that helps identify specific allergens that may trigger allergic responses in your body. This panel tests for a wide range of allergens, including common foods, inhalants like pollen and dust and various drugs. Understanding your allergy triggers can help manage symptoms and avoid allergens effectively. Book Allergy Panel - Food, Inhalant Plus Drug test, if you have adverse reactions to certain foods, environmental factors or medications. Get a FREE home sample collection. ",
  },
  {
    id: "115",
    productName: "Allergy Panel - Food, Inhalant, Non-Veg Plus Drug",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5150,
    description:
      "Allergy Panel: Food, Inhalant, Non-Veg Plus a drug test helps one know about foods, inhalants and medicines one may be allergic to and triggers unusual bodily reactions. It identifies specific allergens and provides details about a comprehensive list of things to be avoided. Book Allergy Panel: Food, Inhalant, Non-Veg Plus Drug test, if you have adverse reactions to certain foods, environmental factors or medications. Get a FREE home sample collection.",
  },
  {
    id: "116",
    productName: "Unconjugated Estriol (E3)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
    description:
      "Unconjugated estriol (E3) is a form of estrogen, which is biologically active. It is exclusively produced during pregnancy, unlike other estrogens. Unconjugated Estriol test is included as part of triple marker and quadruple marker test for antenatal screening for monitoring fetal development and knowing the risk of pregnancy-related complications like premature labor or fetal distress. The level of unconjugated estriol rises during pregnancy, especially in the first trimester. Low levels of unconjugated estriol indicate Down and trisomy-18 syndromes, and neural tube defects. High levels of estriol are observed in cases of congenital adrenal hyperplasia. Take the benefit of free home collection at a much affordable price",
  },
  {
    id: "117",
    productName: "Carbamazepine / Tegretol",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
    description:
      "Carbamazepine is an anti epileptic drug used to treat seizures. Once administered, its absorption in the body is slow and unpredictable with approximately 2-3% of the applied dose discharged via urine. Its concentration peaks about 4-8 hours after ingestion, but it may take up to 26 hours for it to take effect. Monitoring serum carbamazepine levels is done to find out if the drug level is within the therapeutic range there by reducing the risk of toxicity and minimizing the need for additional anticonvulsant medication.",
  },
  {
    id: "118",
    productName: "Anti Hepatitis B Surface Antigen - Total",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 870,
  },
  {
    id: "119",
    productName: "Complement 4 (C4)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 520,
    description:
      "Complement 4 is one of the activation proteins taking part in the classical pathway of the complement system involved in innate and adaptive immunity. The activation of pathways is related to the utilization of C4, thereby reducing its concentration. Complement 4 test measures the amount of C4 proteins in the blood. Decreased levels of C4 are generally associated with angioedema, autoimmune hemolytic anemia, lupus, and rheumatoid arthritis. This test is also used to monitor protein levels in people who have already been diagnosed with an autoimmune disease. Thyrocare offers Complement 4 at the most affordable price. Sample collection at home available.",
  },
  {
    id: "120",
    productName: "Anti Hepatitis B Core Antigen (Ahbc) - Igm",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 670,
    description:
      "Presence of HBcAg (core Antigen) in the cytoplasm and nucleus may reflect disease activity and predict response to antiviral treatment. Anti HBc IgM appears shortly after HBV infection and can be detected in serum soon after the appearance of circulating HBsAg and HBeAg. The levels are high during acute infection and typically disappear within 6 months, though it can persist in some cases of chronic hepatitis. Anti-HBc (IgG antibody) usually remains detectable for a lifetime. The Hepatitis B Core antigen test is used to detect hepatitis B virus (HBV) infection in an individual. This test also helps to assess the risk of re-infection/reactivation. Anti-HBc is the only serological marker that can detect HBV infection and potentially infectious blood. This test cannot differentiate between acute, chronic, and resolved HBV infection.",
  },
  {
    id: "121",
    productName: "Anti Hepatitis B Envelope Antigen (Ahbe) -Total",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 820,
    description:
      "Anti-Hepatitis B Envelop Antigen (Anti-HBe) are antibodies produced by the body in response to the Hepatitis B envelop antigen (HBeAg). When HBeAg appears in blood soon after HBsAg appears or concurrently, it indicates active intrahepatic viral replication which has high chances of transmission.",
  },
  {
    id: "122",
    productName: "17 Oh Progesterone",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 770,
    description:
      "The steroid hormone, 17-hydroxyprogesterone (17-OHP) is produced as a part of the process of synthesizing the cortisol hormone. This 17-OHP test measures the levels of 17-hydroxyprogesterone in the blood to detect Congenital Adrenal Hyperplasia (CAH), an inherited condition that causes decreased adrenal cortisol and aldosterone, and increased male sex hormone (androgen) production. As a part of routine newborn screening, wherein the infant's sex is unclear (ambiguous genitalia) or when a female has increased growth of facial and body hair (hirsutism) or other symptoms that could be related to elevated male sex hormones, or when a male child has premature sexual development, the 17-OPH test can be performed. Avail this test at the lowest price with a free home collection.",
  },
  {
    id: "123",
    productName: "Human Growth Hormone (Hgh)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 520,
    description:
      "Human growth hormone (HGH) is a polypeptide hormone that is secreted by the pituitary gland. It stimulates growth, cell reproduction, and cell regeneration in humans thus influences the normal growth and development of the human body. HGH levels in blood peak during childhood to adolescence, after which they decrease steadily. Deficiency of hGH in children and teenagers results in dwarfism and excess secretion can lead to gigantism. Excess secretion of hGH is generally associated with tumors of the pituitary gland. Thyrocare provides HGH tests at the most reasonable price along with home sample collection.",
  },
  {
    id: "124",
    productName: "Cytomegalo Virus (Cmv) - Igg",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
    description:
      "Cytomegalovirus infection usually goes unnoticed in healthy people, but it can be fatal in immunocompromised people such as HIV-infected people, organ transplant recipients, or newborn babies. Seronegative female patients infected during pregnancy can transmit the disease to the developing fetus, resulting in congenital abnormalities. The Cytomegalovirus-IgG test is important for assessing the patient immunity status and detecting seroconversion. A significant increase in the anti-cytomegalovirus IgG titer is indicative of a recent or past infection or reactivation of a latent infection.",
  },
  {
    id: "125",
    productName: "Complement 3 (C3)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 700,
    description:
      "The complement system important part of the immune system. There are certain plasma proteins involved in the complement system, which destroy the microbes. C3 protein is the critical and most abundant protein in the complement system that helps in killing bacteria and viruses that cause disease. Complement 3 test measures the amount of C3 proteins in the blood. Reduced levels of C3 can help in the diagnosis and monitoring of the treatment of certain diseases. Systemic Lupus Erythematosus (SLE) is one of the autoimmune disorders that often cause abnormal C3 levels. Also, many recurrent bacterial infections are known to occur when there is a deficiency of C3.",
  },
  {
    id: "126",
    productName: "Cardiolipin Antibody (Acl) -Igg",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 760,
    description:
      "Cardiolipin Antibody (ACL) - IgG test detects the presence of Anti Cardiolipin antibodies against cardiolipins. This test is recommended if you have had personal/family history of inappropriate blood clotting, stroke, heart attacks, autoimmune diseases and miscarriages. It is crucial to undergo this test as it can help you prevent some serious health conditions. Elevated levels can indicate the presence of an autoimmune disorder known as antiphospholipid syndrome (APS). Book a test and get free home sample collection",
  },
  {
    id: "127",
    productName: "Treponema Pallidum Haemagglutination",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 520,
    description:
      "Treponema Pallidum Haemagglutination is a test that detects syphilis (a sexually transmitted disease) by detecting palladium antibodies against Treponema Pallidum bacteria. It takes nearly 21-90 days for first symptoms to occur after contracting the bacteria. So, if you've had uprotected sexual intercourse in the recent past or are experiencing any initial symptoms (rashes, fever, swollen lymph nodes, sore throat, patchy hair loss, headaches, weight loss, muscle aches, or fatigue), it is crucial to get tested immediately for timely treatment",
  },
  {
    id: "128",
    productName: "Cardiolipin Antibody (Acl) - Igm",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 760,
    description:
      "This test checks for the presence of cardiolipin antibodies in the blood. Elevated levels are associated with recurrent miscarriage, autoimmune diseases, and abnormal blood clot formation. Cardiolipin Antibody test is available at affordable cost, with a free home collection",
  },
  {
    id: "129",
    productName: "Thyroglobulin (Tg)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1190,
    description:
      "Thyroglobulin (TG) is a glycoprotein that is produced by the follicular cells of the thyroid gland when stimulation is received by the Thyroid Stimulating Hormone (TSH). TG is a precursor for the synthesis of Thyroxine (T4) and Triiodothyronine (T3). It is also an important reservoir of iodine for normal physiological needs. TG undergoes metabolism in the liver and is recycled in the thyroid glands. TG levels are monitored to check the functioning of the thyroid gland. TG test is generally recommended to evaluate the effectiveness of anticancer treatment /surgery in patients suffering from thyroid cancer. Book Thyrocare's Thyroglobulin Test at an inexpensive cost with the home collection.",
  },
  {
    id: "130",
    productName: "Lithium",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 540,
    description:
      "Lithium is used as a medicine to treat psychiatric illnesses such as bipolar disorders, acute mental illness, and other mood disorders. This test is useful to find out the appropriate dose for those who have just started with lithium treatment. It is also used to ensure that the right dosage is being administered throughout the treatment course. Thyrocare offers this test at a discounted price, along with a free home collection facility.",
  },
  {
    id: "131",
    productName: "Adenosine Deaminase",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 760,
    description:
      "Adenosine deaminase (ADA) is a protein produced by body cells and is associated with lymphocyte activation. This test measures the amount of adenosine deaminase in pleural fluid. Elevated ADA levels indicate tuberculosis infection of the pleurae. It also helps to determine infections in other fluids such as peritoneal fluid or cerebrospinal fluid (CSF). Thyrocare now offers an affordable Adenosine Deaminase test with the free home collection.",
  },
  {
    id: "132",
    productName: "Toxo Gondii - Igg",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
    description:
      "Toxoplasma gondii is an intracellular parasitic protozoa that causes Toxoplasmosis. Infection is typically caused by eating contaminated undercooked meat, coming into contact with infected cat feces, or mother-to-child transmission during pregnancy. Most people with the disease have no symptoms, but it can cause serious complications in infants born to infected mothers and immunocompromised people. Toxo Gondii - IgG tests for the presence of IgG antibodies against Toxoplasma gondii and determines whether an individual has previously been infected with the disease. The absence of IgG antibodies before or early in pregnancy identifies women at risk of infection, while the presence of IgG identifies immunocompromised patients at risk of reactivation of a latent infection.",
  },

  {
    id: "133",
    productName: "Anti Phospholipid Antibody (Apl) - Igm",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 870,
    description:
      "Antiphospholipid antibodies are autoantibodies that bind to negatively charged phospholipids. Antiphospholipid Syndrome (APS) is an autoimmune condition with a variety of clinical symptoms such as arterial and venous thrombosis, thrombocytopenia, recurrent fetal loss, and livedo reticularis as well as cardiac, hematological, and neurological manifestations. It has a greater impact on young women than on young men. Antiphospholipid antibody IgM tests help in the detection and risk assessment of thrombosis in patients with Systemic Lupus Erythematosus and APS. This test can be ordered if a person shows signs and symptoms of a blood clot, such as pain and swelling in the extremities, shortness of breath, and headaches. It can also be ordered if a woman has history of miscarriage.",
  },
  {
    id: "134",
    productName: "Cytomegalo Virus (Cmv) - Igm",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
    description:
      "Cytomegalovirus infection usually goes unnoticed in healthy people, but it can be fatal in immunocompromised people such as HIV-infected people, organ transplant recipients, or newborn babies. Seronegative female patients infected during pregnancy can transmit the disease to the developing fetus, resulting in congenital abnormalities. The Cytomegalovirus-IgG test is important for assessing the patients immunity status and detecting seroconversion. A significant increase in the anti-cytomegalovirus IgG titer is indicative of a recent or past infection or reactivation of a latent infection.",
  },
  {
    id: "135",
    productName: "Herpes Simplex Virus (Hsv)-Igm",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
    description:
      "Herpes Simplex Virus, also known as HSV, is a member of the alpha herpesviridae subfamily. The virus has a large double-stranded DNA genome, enclosed by an icosapentahedral capsid made up of capsomers. Infection by HSV causes lesions or blisters on the skin, lips or genital tract. Herpes Simplex Virus I (HSV-I)- IgM test detects the presence of lgM antibodies, which indicates the presence of HSV infections.",
  },
  {
    id: "136",
    productName: "Immunoglobulin G (Igg)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 770,
    description:
      "Immunoglobulin G (IgG) also known as antibody, is a glycoprotein produced by white blood cells. It is a crucial aspect of our immune response system as it specifically identifies and binds to antigens such as viruses and bacteria and aid in their destruction. IgG is a major class of immunoglobulin that provides primary protection against local and systemic infections of the lower respiratory tract. IgG test measures the level of immunoglobulin G in the blood. Analyzing IgG provides valuable insight into the highly complex humoral immune response. During the initial infection or antigen exposure, specific IgG antibodies are formed, which increase a few weeks later, then decrease and stabilise.",
  },
  {
    id: "137",
    productName: "Anti Phospholipid Antibody (Apl) - Igg",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 870,
    description:
      "These are antibodies produced against components of the cell membranes called phospholipids. Elevated levels are indicative of anti-phospholipid syndrome which is an autoimmune disease that results in blood clots, miscarriage and stillbirth.",
  },
  {
    id: "138",
    productName: "Hepatitis B Envelope Antigen (Hbeag)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 870,
  },

  {
    id: "139",
    productName: "Covid Antibody Igg - Elisa",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 400,
    description:
      "Covid antibody test is a sero-surveillance test to understand the immune response against COVID-19 infection. This test detects the presence of IgG antibodies against SARS-CoV-2 virus. However, presence of antibodies indicate an exposure to the virus. Presence of current infection or complete recovery from the infection cannot be interpreted from this test, for which RT-PCR may be opted. Patients medical history, physical findings and other diagnostic procedures should be taken into consideration for interpretation of obtained results.",
  },
  {
    id: "140",
    productName: "Covid Antibody Igm - Elisa",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 300,
    description:
      "Antibody production is the first line of defense against any pathogen. IgM is the first antibody produced in response to attack and is primarily detectable during the early onset of a disease.COVID Antibody IgM is used to semi quantitatively detect these IgM antibodies in blood plasma and serum.If your COVID Antibody IgM test is positive, it indicates that -You have been infected or vaccinated recentlyYour immune system has started responding to the virusesYou may be infected with COVID or recovered recentlyYour body has started responding to the vaccine - Post Vaccination",
  },
  {
    id: "141",
    productName: "Covid Antibodies-Total (Clia)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 500,
    description:
      "COVID Antibodies - Total (C.L.I.A) diagnosis's COVID infection by detecting antibodies in the blood of patients against COVID antigen. This test is specifically recommended for asymptomatic individuals or those with mild symptoms, like cold, cough, flu and loss of smell and taste. Higher levels of IgG in your body indicate a previous infection. Book a test and benefit from free home sample collection",
  },
  {
    id: "142",
    productName: "Interleukin-6",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1030,
    description:
      "Interleukin 6 (IL-6) is a protein produced in different cells. It is a part of a large group of molecules called cytokines. Cytokines have multiple roles to play, especially with directing the body’s immune system. It is produced in response to inflammation, infection, autoimmune disorders, cardiovascular diseases, and some cancers. It functions through activation of the acquired immune system (B and T cells) as well as the innate immune system. It contributes to host defense through the stimulation of acute-phase responses, producing new blood cells, and immune reactions. Book IL6 test at an affordable price, with free home collection from Thyrocare.",
  },

  {
    id: "143",
    productName: "Antidnase-B (Dnb)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 4120,
    description:
      "The Anti-DNase B (DNB) test checks for past or recent Strep Throat infection. It detects antibodies produced by the body against Group A streptococcus (GAS) bacteria which cause this Strep throat. This test is highly recommended if you have come in direct contact with an infected person or are experiencing symptoms like cough, hoarseness, fever, pain while swallowing, red/swollen tonsils, white patches on the tonsils, tiny red spots on the palate and swollen lymph nodes near the neck. Book the test at the most affordable rates",
  },
  {
    id: "144",
    productName: "Hiv-1, Rna Quantitative Pcr",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3910,
    description:
      "The test measures the quantity of HIV viral RNA present in the body. It tells you about disease progress and the response to ongoing antiretroviral therapy, which helps your doctor recommend a more effective treatment regimen if required. The test is also recommended as a preliminary test to detect the presence of HIV in the body. Book now at affordable rates and get a free home sample collection",
  },
  {
    id: "145",
    productName: "Hepatitis B Virus (Hbv) Qualitative Pcr",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3240,
    description:
      "Hepatitis B Virus (HBV) Qualitative PCR test detects hepatitis infections. The parameters encompass various antigens that evaluate the presence of Hepatitis B virus in your body. This test is typically recommended for individuals who show symptoms such as fatigue, poor appetite, stomach pain, nausea and jaundice. The test also aids in detecting current or past infections, assessing the contagiousness and severity of the infection as well as determining if it has caused liver damage. Get tested for the infection today to mitigate any future complications. Book a test at the most competitive market rates and get from free home sample collection",
  },
  {
    id: "146",
    productName: "Hepatitis C Virus (Hcv) Qualitative Pcr",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3240,
    description:
      "Hepatitis C Virus (HCV) Qualitative PCR test detects HCV infection by identifying antibodies to HCV in your bloodstream. This test is typically recommended for individuals who show symptoms such as fever, fatigue, decreased appetite, nausea, vomiting, abdominal pain, dark urine, pale stools, joint pain and jaundice. In its chronic stage, this virus can give rise to severe liver problems like cirrhosis and liver cancer. It is advisable to undergo timely testing for early prevention. Book a test and enjoy free home sample collection",
  },
  {
    id: "147",
    productName: "Tsh - Ultrasensitive",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
    description:
      "TSH - Ultrasensitive is a blood test that measures the TSH levels in your body. Ultrasensitive TSH test diagnoses thyroid hormonal imbalance and disorders and monitors treatment response. It also screens the newborn for congenital hypothyroidism. Ultrasensitive TSH ensures highest sensitive and accuracy on the detection. Book a test now if you notice symptoms like hair fall, skin problems, losing or gaining weight, swollen throat, exhaustion, and blurry vision",
  },
  {
    id: "148",
    productName: "Troponin I Heart Attack Risk",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 650,
    description:
      "Cardiac troponin I is a protein found in the cells of your heart muscles. It is released into the bloodstream when your heart muscle is injured. The level of troponin I in the blood can be measured by taking a blood test. In individuals who appear healthy and have no symptoms of cardiovascular disease, the Troponin I Heart Attack Risk helps determine the risk of a future heart attack or other cardiovascular diseases. Add Thyrocare’s Troponin I Heart Attack Risk test to your health checks to help identify your risk of heart.",
  },
  {
    id: "149",
    productName: "Covid Antibody Igg (Quantitative)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 410,
    description:
      "COVID Antibody test is used to recognize individuals with adaptive immune response against SARS-CoV-2, which indicates a recent or prior infection. Generally, IgG antibodies start to develop after 2 weeks from the onset or after recovering from an infection.",
  },
  {
    id: "150",
    productName: "Chromogranin A",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5150,
  },
  {
    id: "151",
    productName: "Intolerance - Cow Milk",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1030,
  },
  {
    id: "152",
    productName: "Intolerance - Curd",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1030,
  },
  {
    id: "153",
    productName: "Intolerance - Yogurt",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1030,
  },
  {
    id: "154",
    productName: "Intolerance - Mozzarella Cheese",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1030,
  },
  {
    id: "155",
    productName: "Intolerance - Buffalo Milk",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 410,
    description:
      "COVID Antibody test is used to recognize individuals with adaptive immune response against SARS-CoV-2, which indicates a recent or prior infection. Generally, IgG antibodies start to develop after 2 weeks from the onset or after recovering from an infection.",
  },
  {
    id: "156",
    productName: "Direct Renin",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 4500,
  },
  {
    id: "157",
    productName: "Blood Urea Nitrogen (Bun)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 110,
    description:
      "COVID Antibody test is used to recognize individuals with adaptive immune response against SARS-CoV-2, which indicates a recent or prior infection. Generally, IgG antibodies start to develop after 2 weeks from the onset or after recovering from an infection.",
  },
  {
    id: "158",
    productName: "Alanine Transaminase (SGPT)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 200,
  },
  {
    id: "159",
    productName: "Total Cholesterol",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
  },
  {
    id: "160",
    productName: "Chloride",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 220,
  },
  {
    id: "161",
    productName: "Free Beta HCG",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
  },
  {
    id: "162",
    productName: "Uric Acid",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 200,
  },
  {
    id: "163",
    productName: "MYOGLOBIN",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1030,
  },
  {
    id: "164",
    productName: "DIHYDROTESTOSTERONE (DHT)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1030,
  },
  {
    id: "165",
    productName: "HELICOBACTER PYLORI - IGG",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1030,
  },
  {
    id: "166",
    productName: "Herpes Simplex Virus II (HSV)-IGG",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
    description:
      "COVID Antibody test is used to recognize individuals with adaptive immune response against SARS-CoV-2, which indicates a recent or prior infection. Generally, IgG antibodies start to develop after 2 weeks from the onset or after recovering from an infection.",
  },
  {
    id: "167",
    productName: "Herpes Simplex Virus II (HSV)-IGM",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
  },
  {
    id: "168",
    productName: "Insulin Like Growth Factor 1",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 820,
  },
  {
    id: "169",
    productName: "Reticulocyte Count (%)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
  },
  {
    id: "170",
    productName: "Transferrin Serum",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 410,
  },
  {
    id: "171",
    productName: "Adrenocorticotropic Homone (ACTH)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 770,
  },

  {
    id: "172",
    productName: "Anti Chlamydia Antibody IGG",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
  },
  {
    id: "173",
    productName: "Anti Chlamydia Antibody IGM",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
  },

  {
    id: "174",
    productName: "Direct Coombs Test",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
  },
  {
    id: "175",
    productName: "Helicobacter Pylori - IGM",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 820,
  },
  {
    id: "176",
    productName: "Neonatal Hemoglobin Electrophoresis",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 770,
  },

  {
    id: "177",
    productName: "Serum Globulin",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
  },
  {
    id: "178",
    productName: "Acetylcholine Receptor Autoantibody",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 2060,
  },

  {
    id: "179",
    productName: "Anti Deamidated Gliadin Peptide - Iga",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
  },
  {
    id: "180",
    productName: "Anti Deamidated Gliadin Peptide - Igg",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
  },

  {
    id: "181",
    productName: "Benzodiazepines",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
  },
  {
    id: "182",
    productName: "Chromium",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1030,
  },
  {
    id: "183",
    productName: "Copper",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1030,
  },
  {
    id: "184",
    productName: "Digoxin",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
  },
  {
    id: "185",
    productName: "Covid Antibody Igg (Quantitative)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 410,
    description:
      "COVID Antibody test is used to recognize individuals with adaptive immune response against SARS-CoV-2, which indicates a recent or prior infection. Generally, IgG antibodies start to develop after 2 weeks from the onset or after recovering from an infection.",
  },
  {
    id: "186",
    productName: "Epstein Barr Viral Capsid Antigen - IgG",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1240,
  },
  {
    id: "187",
    productName: "Filaria Antigen Rapid Test",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1240,
  },
  {
    id: "188",
    productName: "Gastrin",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 720,
  },
  {
    id: "189",
    productName: "Glucose Tolerance Test (2 Hour)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 100,
  },
  {
    id: "190",
    productName: "Insulin Antibodies",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1240,
    description:
      "COVID Antibody test is used to recognize individuals with adaptive immune response against SARS-CoV-2, which indicates a recent or prior infection. Generally, IgG antibodies start to develop after 2 weeks from the onset or after recovering from an infection.",
  },
  {
    id: "191",
    productName: "Manganese",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1030,
  },
  {
    id: "192",
    productName: "Covid Antibody Igg (Quantitative)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 410,
    description:
      "COVID Antibody test is used to recognize individuals with adaptive immune response against SARS-CoV-2, which indicates a recent or prior infection. Generally, IgG antibodies start to develop after 2 weeks from the onset or after recovering from an infection.",
  },
  {
    id: "193",
    productName: "Methaqualine",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 620,
  },

  {
    id: "194",
    productName: "Mumps Antibody - IGM",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 620,
  },
  {
    id: "195",
    productName: "Nicotine Metabolites",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1850,
  },
  {
    id: "196",
    productName: "Pyruvate",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
  },
  {
    id: "197",
    productName: "Selenium",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1030,
  },
  {
    id: "198",
    productName: "Varicella Zoster Virus Antibody - IGM",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 720,
  },
  {
    id: "199",
    productName: "Vitamin B1/Thiamin",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1030,
    description:
      "COVID Antibody test is used to recognize individuals with adaptive immune response against SARS-CoV-2, which indicates a recent or prior infection. Generally, IgG antibodies start to develop after 2 weeks from the onset or after recovering from an infection.",
  },
  {
    id: "200",
    productName: "Vitamin B7/Boitin",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1030,
  },
  {
    id: "201",
    productName: "Vitamin K",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 2060,
  },
  {
    id: "202",
    productName: "1,5 Anhydroglucitol",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 820,
  },
  {
    id: "203",
    productName: "AFB Drug Susceptibility - MOTT",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5200,
  },
  {
    id: "204",
    productName: "Alcohol",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 620,
  },
  {
    id: "205",
    productName: "Aldolase",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1030,
  },
  {
    id: "206",
    productName: "Alpha Hydroxybutyrate Dehydrogenase",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
  },
  {
    id: "207",
    productName: "Alpha1 Acid Glycoprotein",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 620,
    description:
      "COVID Antibody test is used to recognize individuals with adaptive immune response against SARS-CoV-2, which indicates a recent or prior infection. Generally, IgG antibodies start to develop after 2 weeks from the onset or after recovering from an infection.",
  },
  {
    id: "208",
    productName: "Alpha2 Macroglubulin",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 620,
  },
  {
    id: "209",
    productName: "Antithrombin III",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1200,
  },
  {
    id: "210",
    productName: "Barium",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1030,
  },
  {
    id: "211",
    productName: "Beryllium",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1030,
  },
  {
    id: "212",
    productName: "Bismuth",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1030,
  },
  {
    id: "213",
    productName: "Ketamine",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
  },
  {
    id: "214",
    productName: "Methamphetamine",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
  },
  {
    id: "215",
    productName: "Morphine",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
  },
  {
    id: "216",
    productName: "HLA B27 Qualitative PCR",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 2060,
  },
  {
    id: "217",
    productName: "Allergy Panel - Food",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 2050,
  },
  {
    id: "218",
    productName: "Sickle cells in Blood By Light microscopy - INLAB",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 800,
  },
  {
    id: "219",
    productName: "Albumin - Serum",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
    description:
      "COVID Antibody test is used to recognize individuals with adaptive immune response against SARS-CoV-2, which indicates a recent or prior infection. Generally, IgG antibodies start to develop after 2 weeks from the onset or after recovering from an infection.",
  },
  {
    id: "220",
    productName: "Malarial Parasite",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
  },
  {
    id: "221",
    productName: "Triglycerides",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
  },
  {
    id: "222",
    productName: "Bicarbonate",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 520,
  },
  {
    id: "223",
    productName: "Hepatitis C Virus (HCV) Quantitative PCR",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3840,
  },
  {
    id: "224",
    productName: "Indirect Coombs Test",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
  },
  {
    id: "225",
    productName: "Covid Antibody Igg (Quantitative)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 410,
    description:
      "COVID Antibody test is used to recognize individuals with adaptive immune response against SARS-CoV-2, which indicates a recent or prior infection. Generally, IgG antibodies start to develop after 2 weeks from the onset or after recovering from an infection.",
  },
  {
    id: "226",
    productName: "Ana Titre (Immunofluorescence)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 770,
  },
  {
    id: "227",
    productName: "Antinuclear Antibodies-17 BLOT",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3300,
  },
  {
    id: "228",
    productName: "Vitamin D3",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 2100,
  },
  {
    id: "229",
    productName: "Covid Antibody Igg (Quantitative)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 410,
    description:
      "COVID Antibody test is used to recognize individuals with adaptive immune response against SARS-CoV-2, which indicates a recent or prior infection. Generally, IgG antibodies start to develop after 2 weeks from the onset or after recovering from an infection.",
  },
  {
    id: "230",
    productName: "Aspartate Aminotransferase (SGOT)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 200,
  },
  {
    id: "231",
    productName: "Blood Urea",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 120,
  },
  {
    id: "232",
    productName: "Hepatitis B Surface Antigen(HBSAG) Rapid Test",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 460,
  },
  {
    id: "233",
    productName: "Hemoglobin",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 200,
  },
  {
    id: "234",
    productName: "Hepatitis B Virus (HBV) Quantitative PCR",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3710,
  },
  {
    id: "235",
    productName: "Bilirubin - Total",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
  },
  {
    id: "236",
    productName: "Protein - Total",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
  },
  {
    id: "237",
    productName: "Gamma Glutamyl Transferase(GGT)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
  },
  {
    id: "238",
    productName: "Ionic Calcium",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
  },
  {
    id: "239",
    productName: "Vitamin B9/Folic Acid",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1030,
  },
  {
    id: "240",
    productName: "Anti Hepatitis A Virus (HAV) - Total",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 670,
  },
  {
    id: "241",
    productName: "LDL Cholesterol - Direct",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
  },
  {
    id: "242",
    productName: "Beta 2 Glycoprotein 1 - IGG",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 520,
  },
  {
    id: "243",
    productName: "Beta 2 Glycoprotein 1 - IGM",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 520,
  },
  {
    id: "244",
    productName: "Immunoglobulin E (IGE)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1240,
  },
  {
    id: "245",
    productName: "Protein Electrophoresis",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 820,
  },
  {
    id: "246",
    productName: "Bilirubin - Direct",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
  },
  {
    id: "247",
    productName: "MPO - ANCA (P - ANCA)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 770,
  },
  {
    id: "248",
    productName: "PR3 - ANCA (C - ANCA)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1220,
  },
  {
    id: "249",
    productName: "High Sensitivity Troponin I",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 520,
  },
  {
    id: "250",
    productName: "Covid Antibody Igg (Quantitative)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 410,
    description:
      "COVID Antibody test is used to recognize individuals with adaptive immune response against SARS-CoV-2, which indicates a recent or prior infection. Generally, IgG antibodies start to develop after 2 weeks from the onset or after recovering from an infection.",
  },
  {
    id: "251",
    productName: "TSH Receptor Antibodies",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1240,
  },
  {
    id: "252",
    productName: "Angiotensin Converting Enzyme",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 620,
  },
  {
    id: "253",
    productName: "Amphetamine",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
  },
  {
    id: "254",
    productName: "Cocaine",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
  },
  {
    id: "255",
    productName: "HIV - Western Blot",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3090,
  },
  {
    id: "256",
    productName: "Leptospira - IgM",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 520,
  },
  {
    id: "257",
    productName: "Opiates",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
  },
  {
    id: "258",
    productName: "Phencyclidine",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
  },
  {
    id: "259",
    productName: "Platelet Count",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 270,
  },
  {
    id: "260",
    productName: "TB XDR Screen (LPA)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3140,
  },
  {
    id: "261",
    productName: "Tetrahydrocannabinol",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
  },
  {
    id: "262",
    productName: "APTT",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 450,
  },

  {
    id: "263",
    productName: "Calcitonin",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 620,
  },
  {
    id: "264",
    productName: "Cholinesterase",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
  },
  {
    id: "265",
    productName: "Cotinine",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
  },
  {
    id: "266",
    productName: "Ethanol",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 520,
  },
  {
    id: "267",
    productName: "Genexpert",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 2900,
  },
  {
    id: "268",
    productName: "HDL Cholesterol - Direct",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
  },
  {
    id: "269",
    productName: "Hepatitis C Virus - IGG",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 410,
  },
  {
    id: "270",
    productName: "HIV-1, RNA Qualitative PCR",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 2580,
  },
  {
    id: "271",
    productName: "Lactate",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 410,
  },
  {
    id: "272",
    productName: "Liver Kidney Microsomes",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 770,
  },
  {
    id: "273",
    productName: "Pregnancy Associated Plasma Protein A",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
  },
  {
    id: "274",
    productName: "Urine Pregnancy Rapid Test",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
  },
  {
    id: "275",
    productName: "Varicella Zoster Virus Antibody - IGG",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 720,
  },
  {
    id: "276",
    productName: "Vitamin A",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 2060,
  },
  {
    id: "277",
    productName: "Vitamin B6/Pyridoxal - 5 - Phosphate",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1030,
  },
  {
    id: "278",
    productName: "Acid Phosphatase",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 410,
  },
  {
    id: "279",
    productName: "Barbiturates",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
  },
  {
    id: "280",
    productName: "Beta2 Microglobulin",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 620,
  },
  {
    id: "281",
    productName: "Echinococcus - IGG",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 310,
  },
  {
    id: "282",
    productName: "Glucose Tolerence Test (1 Hour)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 120,
  },
  {
    id: "283",
    productName: "Haptoglobin",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 410,
  },
  {
    id: "284",
    productName: "Helicobacter Pylori - IgA",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1030,
  },
  {
    id: "285",
    productName: "Hepatitis A Virus Antibody IGM(HAVM) Rapid Test",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 460,
  },
  {
    id: "286",
    productName: "Hepatitis C Virus - IGM",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 980,
  },
  {
    id: "287",
    productName: "Hepatitis E Virus - IGG",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 520,
  },
  {
    id: "288",
    productName: "Kappa Light Chain",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 620,
  },
  {
    id: "289",
    productName: "Lambda Light Chain",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 620,
  },
  {
    id: "290",
    productName: "Lead",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1030,
  },
  {
    id: "291",
    productName: "Measles Antibody - IGG",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 620,
  },
  {
    id: "292",
    productName: "Measles Antibody - IGM",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 620,
  },
  {
    id: "293",
    productName: "Methadone",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
  },
  {
    id: "294",
    productName: "Miscellaneous Culture And Susceptibility",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 830,
  },
  {
    id: "295",
    productName: "Mumps Antibody - IGG",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 620,
  },
  {
    id: "296",
    productName: "Neonatal Thyroid Stimulating Hormone #(TSH)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
  },
  {
    id: "297",
    productName: "Propoxyphene",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 210,
  },
  {
    id: "298",
    productName: "TB PCR",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1750,
  },
  {
    id: "299",
    productName: "Zinc",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1030,
  },

  {
    id: "300",
    productName:
      "5-Fu Genotyping And Toxicity Test (pharmacogenomics) - (Outlab)",
    imgUrl: bloodTest01,
    category: "Blood",
    price: 3624,
    shortDesc:
      "Fasting Blood Sugar test is generally run to measure the amount of blood sugar after minimum 8 long hours of complete fasting.",
    description:
      "Fasting Blood Sugar test is generally run to measure the amount of blood sugar after minimum 8 long hours of complete fasting. After a whole night without any kind of food, this test is run to properly monitor the chances of diabetes in individuals. This test is the fastest and simplest test to detect the probabilities of diabetes. Diseases like Diabetes do not generate any symptoms initially. There lies the importance of this test. This is why this test is recommended for everyone who are above 45 age. You must fast for a whole night before the test or at least for 8 to 12 hours. Following the instructions of your doctor is also necessary even if you are on medication. If your Fasting Blood Sugar level is lower than normal, then it may cause a disease named hypoglycemia.",
  },

  {
    id: "301",
    productName: "Adenosine Deaminase, Ada-Ascitic Fluid - (Outlab)",
    imgUrl: bloodTest01,
    category: "blood",
    price: 1200,
    shortDesc:
      "HbA1c Test is used to quickly measure the amount of blood sugar that remains attached with Haemoglobin.",
    description:
      "HbA1c Test is used to quickly measure the amount of blood sugar that remains attached with Haemoglobin. Knowingly, the combination of Haemoglobin and glucose is known as HbA1c (glycated or glycosylated haemoglobin). Generally, this test is run to detect the possibilities of diabetes and prediabetes in adults. Everyone should go for this test for at least once in three months because the lifespan of red blood cells is usually 3 months. Your habit of smoking may affect your test results passively. Tests like Glycosylated HB Blood, Diabetes test, A1c Test, H1C test, A1c Haemoglobin test, Glycosylated HB are included in an HbA1c test. No hardcore preparations are needed to go for this test. You just need to follow the instructions given by your doctor before the test. If the value remains greater than 5.7 in your test results, then its normal. HBA1C Test Price is Rs. 375.",
  },

  {
    id: "302",
    productName: "Adenosine Deaminase, Ada-Csf - (Outlab)",
    imgUrl: bloodTest01,
    category: "sofa",
    price: 1200,
    shortDesc:
      "This test is merely done to measure the level of Thyroid Stimulating Hormone quickly.",
    description:
      "This test is merely done to measure the level of Thyroid Stimulating Hormone quickly. This is one specific kind of pituitary hormone that stimulates the thyroid gland. This test is also necessary for everyone as thyroid disorders are also known for turning incurable if not detected or treated on time. The prime objective of this test is to determine that the thyroid gland is hyperactive or underactive. If you are having any kind of thyroid disorders, then your doctor may suggest you to go for a test. If the thyroid gland starts to produce huge amount of Thyroid Stimulating Hormone, then a specific health condition starts to occur that is known as hypothyroidism. No specific preparations are required for this test. You just need to follow the instructions of your doctor in a proper manner. The thyroid gland functionality remains different in every person, which impacts the test results. Besides, the test results may also vary depending upon age, gender or health condition.",
  },
  {
    id: "303",
    productName: "Adenosine Deaminase, Ada-Fluid - (Outlab)",
    imgUrl: bloodTest01,
    category: "sofa",
    price: 1200,
    shortDesc:
      "An erythrocyte sedimentation rate (ESR) is a type of blood test that measures how quickly erythrocytes (red blood cells) settle at the bottom of a test tube that contains a blood sample.",
    description:
      "An erythrocyte sedimentation rate (ESR) is a type of blood test that measures how quickly erythrocytes (red blood cells) settle at the bottom of a test tube that contains a blood sample. Normally, red blood cells settle relatively slowly. A faster-than-normal rate may indicate inflammation in the body.",
  },
  {
    id: "304",
    productName: "AFB CULTURE (MGIT)",
    imgUrl: bloodTest01,
    category: "sofa",
    price: 1200,
    shortDesc:
      "FT4 and FT3 are also two of the most important tests. Knowingly, T3 only represents just 5% of normal thyroid hormone.",
    description:
      "FT4 and FT3 are also two of the most important tests. Knowingly, T3 only represents just 5% of normal thyroid hormone. Measurement of free triiodothyronine is the prime reason why this test is run. Decreasing amount of FT4 may cause hypothyroidism, which may cause several types of disorders. FT4 is known for comprising a little fraction of total thyroxine that remains available to the body tissues. Free T3 and T4 blood tests are included in all kinds of FT4 tests. You must inform your doctor before the test if you are already on medication or having any kind of allergies. No other specific preparations are needed for these tests. However, 10-12 hours of complete fasting is necessary before appearing for the test. The test results may vary depending upon gender and age or the health condition of the patient.",
  },

  {
    id: "305",
    productName: "AFB DRUG SUSCEPTIBILITY - MOTT",
    imgUrl: bloodTest01,
    category: "sofa",
    price: 5200,
    shortDesc:
      "C-reactive protein test or CRP test helps to detect lower levels of the protein in the bloodstream. The level increases in case of inflammation. Determining the potentiality of inflammation is possible through this test.",
    description:
      "C-reactive protein test or CRP test helps to detect lower levels of the protein in the bloodstream. The level increases in case of inflammation. Determining the potentiality of inflammation is possible through this test. In case you are going through acute conditions that can cause inflammation, experts can recommend you to go for a CRP blood test. Doctors say, CRP test in Covid is very important. You can now easily avail the facility of CRP test at home because CRP test cost is not really too high.",
  },

  {
    id: "306",
    productName: "AFB DRUG SUSCEPTIBILITY (13 DRUGS)",
    imgUrl: bloodTest01,
    category: "sofa",
    price: 7900,
    shortDesc:
      "HCG represents human chorionic gonadotropin, a hormone which is produced during pregnancy.",
    description:
      "HCG represents human chorionic gonadotropin, a hormone which is produced during pregnancy. The Free Beta HCG test helps to detect the presence of HCG in your blood.",
  },
  {
    id: "307",
    productName: "AFB DRUG SUSCEPTIBILITY (KCLM) 2ND LINE",
    imgUrl: bloodTest01,
    category: "chair",
    price: 4600,
    shortDesc:
      "This test is performed to measure the amount of Prolactin in Blood. Prolactin is a specific type of hormone that is produced by the Pituitary gland.",
    description:
      "This test is performed to measure the amount of Prolactin in Blood. Prolactin is a specific type of hormone that is produced by the Pituitary gland. For both men and women, this hormone plays a very important role to maintain a proper reproductive system. The test is mostly run on women in case of irregular menstrual period or infertility issues. Abnormal growth of body, facial hair, decreased sex drive are some of the symptoms of the crisis of Prolactin. No specific preparations are required to appear for this test. However, the perfect time to collect blood samples for this test is 3-4 hours after waking up in the morning as prolactin levels in the blood may vary over a 24 hours span. The test results may vary depending on age, gender and health condition. Low prolactin level may cause a disorder named hypopituitarism. Similarly, high prolactin level may cause some types of physical complexions. However, high prolactin levels are normal in pregnant women.",
  },

  {
    id: "308",
    productName: "AFB DRUG SUSCEPTIBILITY (KEPO) 2ND LINE",
    imgUrl: bloodTest01,
    category: "sofa",
    price: 3000,
    shortDesc:
      "This test is also known as Triiodothyronine blood test. This test is merely run to measure the actual amount of free Triiodothyronine or FT-3 in blood.",
    description:
      "This test is also known as Triiodothyronine blood test. This test is merely run to measure the actual amount of free Triiodothyronine or FT-3 in blood. Triiodothyronine is a type of hormone that is produced by the Thyroid gland. The main objective of this test is to determine that the thyroid gland is hyperactive or underactive. Imbalancement of such hormone production may cause irritability, irregular heartbeats and many other physical complexions and disorders. This is why Free Triiodothyronine test is also important for everyone. You may need to fast for a certain span of time before appearing for the test. There are some types of drugs including birth control pills that may affect the test results. This is why consulting a doctor is necessary before appearing for Free Triiodothyronine test. Test results may vary depending upon age, gender and health condition of the patient.",
  },

  {
    id: "309",
    productName: "AFB DRUG SUSCEPTIBILITY (MACC) 2ND LINE",
    imgUrl: bloodTest01,
    category: "chair",
    price: 3000,
    shortDesc:
      "This is also one of the major tests. PSA is one type of protein that is produced by the prostate cells of a male body.",
    description:
      "This is also one of the major tests. PSA is one type of protein that is produced by the prostate cells of a male body. A PSA test is merely run to determine the chances of prostate cancer. If somebody has a family history of Prostate cancer, then he must go for this test. PSA test is a prime chapter of prostate cancer treatment. The patient need to stay away from masterbation for at least 3 days before appearing for this test. Following all the instructions given by the doctor is also necessary before appearing for the test. The test results may vary depending upon age, gender and health conditions.",
  },

  {
    id: "310",
    productName: "AFB DRUG SUSCEPTIBILITY (SIRE) 1ST LINE",
    imgUrl: bloodTest01,
    category: "chair",
    price: 3000,
    shortDesc:
      "Diagnosing autoimmune disorders like rheumatoid arthritis is the prime objective of this test.",
    description:
      "Diagnosing autoimmune disorders like rheumatoid arthritis is the prime objective of this test. Besides, this test is also performed to diagnose the severity of any disease. Knowingly, the Rheumatoid Factor test price is very reasonable.",
  },

  {
    id: "311",
    productName: "AFB DRUG SUSCEPTIBILITY (SIREP) 1ST LINE",
    imgUrl: bloodTest01,
    category: "mobile",
    price: 3800,
    shortDesc:
      "Through this test, the level of Vitamin-B12 in blood is tested. Vitamin B12 is one of the most important elements of the human body that helps to improve blood and nerve cells.",
    description:
      "Through this test, the level of Vitamin-B12 in blood is tested. Vitamin B12 is one of the most important elements of the human body that helps to improve blood and nerve cells. It also plays a vital role in the synthesis of DNA. Vitamin B-12 test is mainly performed to check that a person is having a normal level of Vitamin B-12 or not. Lack of Vitamin B-12 may cause a massive decrement of red blood cells that can cause Anemia. This is why Vitamin B-12 test is recommended for everyone. You must inform your doctor and follow all the given instructions before appearing for the test. You must fast for one complete night or 8-12 long hours before the date of test. No other precautions are required to appear for this test. If the test result shows that the level of Vitamin B-12 is lower than normal, then it may be a primary symptom of Anemia. Consulting a doctor after getting the test results is recommended. Vitamin B-12 test price is Rs.800 with Free Home Sample Collection.",
  },
  {
    id: "312",
    productName: "Allergy Panel - Drug - (Outlab)",
    imgUrl: bloodTest01,
    category: "chair",
    price: 2000,
  },
  {
    id: "313",
    productName: "Allergy Panel - Food - (Outlab)",
    imgUrl: bloodTest01,
    category: "mobile",
    price: 1986,
  },

  {
    id: "314",
    productName: "Allergy Panel - Food Plus Drug - (Outlab)",
    imgUrl: bloodTest01,
    category: "mobile",
    price: 3805,
  },

  {
    id: "315",
    productName: "Allergy Panel - Food Plus Inhalant - (Outlab)",
    imgUrl: bloodTest01,
    category: "mobile",
    price: 2440,
  },

  {
    id: "316",
    productName: "Allergy Panel - Food Plus Non-Veg - (Outlab)",
    imgUrl: bloodTest01,
    category: "mobile",
    price: 3198,
  },

  {
    id: "317",
    productName: "Allergy Panel - Food, Inhalant Plus Drug - (Outlab)",
    imgUrl: bloodTest01,
    category: "mobile",
    price: 4108,
  },

  {
    id: "318",
    productName: "Allergy Panel - Food, Inhalant Plus Non-Veg - (Outlab)",
    imgUrl: bloodTest01,
    category: "watch",
    price: 3350,
  },

  {
    id: "319",
    productName: "Allergy Panel - Food, Inhalant, Non-Veg Plus Drug - (Outlab)",
    imgUrl: bloodTest01,
    category: "watch",
    price: 5000,
  },

  {
    id: "320",
    productName: "Allergy Panel - Inhalant - (Outlab)",
    imgUrl: bloodTest01,
    category: "watch",
    price: 1531,
  },

  {
    id: "321",
    productName: "Allergy Panel - Non-Veg - (Outlab)",
    imgUrl: bloodTest01,
    category: "watch",
    price: 1200,
  },

  {
    id: "322",
    productName:
      "Aml Multiplex Basic Reflex To Flt3-Itd Allelic Ratio - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 17342,
  },

  {
    id: "323",
    productName: "Aml1/Eto (aml - M2) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5213,
  },
  {
    id: "324",
    productName: "Amniotic Fluid For Karyotyping - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 10122,
  },
  {
    id: "325",
    productName: "Aneuploidy Fish (13, 18, 21, X & Y) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 8000,
  },
  {
    id: "326",
    productName: "ANTIBIOGRAM - MTB (AMIKACIN)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1500,
  },
  {
    id: "327",
    productName: "ANTIBIOGRAM - MTB (CAPREOMYCIN)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1500,
  },
  {
    id: "328",
    productName: "ANTIBIOGRAM - MTB (CLOFAZIMINE)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1500,
  },
  {
    id: "329",
    productName: "ANTIBIOGRAM - MTB (ETHAMBUTOL)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1500,
  },
  {
    id: "330",
    productName: "ANTIBIOGRAM - MTB (ETHIONAMIDE)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1500,
  },
  {
    id: "331",
    productName: "ANTIBIOGRAM - MTB (ISONIAZID)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1500,
  },
  {
    id: "332",
    productName: "ANTIBIOGRAM - MTB (KANAMYCIN)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1500,
  },
  {
    id: "333",
    productName: "ANTIBIOGRAM - MTB (LINEZOLID)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1500,
  },
  {
    id: "334",
    productName: "ANTIBIOGRAM - MTB (MOXIFLOXACIN HIGHER DOSE)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1500,
  },
  {
    id: "335",
    productName: "ANTIBIOGRAM - MTB (MOXIFLOXACIN)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1500,
  },
  {
    id: "336",
    productName: "ANTIBIOGRAM - MTB (OFLOXACIN)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1500,
  },
  {
    id: "337",
    productName: "ANTIBIOGRAM - MTB (PAS)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1500,
  },
  {
    id: "338",
    productName: "ANTIBIOGRAM - MTB (PYRAZINAMIDE)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1500,
  },

  {
    id: "339",
    productName: "ANTIBIOGRAM - MTB (RIFABUTIN)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1500,
  },
  {
    id: "340",
    productName: "ANTIBIOGRAM - MTB (RIFAMPICIN)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1500,
  },
  {
    id: "341",
    productName: "ANTIBIOGRAM - MTB (STREPTOMYCIN)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1500,
  },
  {
    id: "342",
    productName: "Ascitic Fluid Analysis With Ada - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1400,
  },
  {
    id: "343",
    productName: "Ascitic Fluid Analysis With Afb - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 800,
  },
  {
    id: "344",
    productName: "Ascitic Fluid Cytology - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 592,
  },
  {
    id: "345",
    productName: "BACTERIAL LATEX AGGLUTINATION",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1500,
  },
  {
    id: "346",
    productName: "Bcr/Abl (cml, Aml, All) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3913,
  },
  {
    id: "347",
    productName: "Bcr/Abl Qualitative (mbcr-Cml) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 4500,
  },
  {
    id: "348",
    productName: "Bcr/Abl Quantitative (mbcr-Cml) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5500,
  },
  {
    id: "349",
    productName: "Bence Jones Protein - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 800,
  },
  {
    id: "350",
    productName: "Beta Thalassemia 20 Mutations - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 12765,
  },
  {
    id: "351",
    productName: "Beta Thalassemia 20 Mutations (3 Family Members) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 20274,
  },
  {
    id: "352",
    productName: "Beta Thalassemia 20 Mutations (couple) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 16519,
  },
  {
    id: "353",
    productName: "Beta Thalassemia 6 Mutations - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 6801,
  },
  {
    id: "354",
    productName: "Beta Thalassemia 6 Mutations (3 Family Members) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 11278,
  },
  {
    id: "355",
    productName: "Beta Thalassemia 6 Mutations (couple) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 9025,
  },
  {
    id: "356",
    productName: "Beta Thalassemia Additional 14 Mutations - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 10541,
  },
  {
    id: "357",
    productName:
      "Beta Thalassemia Additional 14 Mutations (3 Family Members) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 16519,
  },
  {
    id: "358",
    productName: "Beta Thalassemia Additional 14 Mutations (couple) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 13530,
  },
  {
    id: "359",
    productName:
      "Beta Thalassemia Single Gene Mutation Confirmation - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5285,
  },
  {
    id: "360",
    productName:
      "Blau Syndrome (nod2/Card15 Gene) (exon 4 Part 1-5) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 26613,
  },
  {
    id: "361",
    productName: "BLOOD CULTURE AND SUSCEPTIBILITY (ADULT)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 800,
  },
  {
    id: "362",
    productName: "BLOOD CULTURE AND SUSCEPTIBILITY (PEDIATRIC)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 800,
  },
  {
    id: "363",
    productName: "Blood Karyotype With Variants - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5040,
  },
  {
    id: "364",
    productName: "Body Fluid (csf/Ascitic Fluid) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 600,
  },
  {
    id: "365",
    productName: "Bone Marrow For Karyotyping - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3336,
  },
  {
    id: "366",
    productName: "Bone Marrow Karyotyping - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 9039,
  },
  {
    id: "367",
    productName: "Bone Marrow Smear - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 600,
  },
  {
    id: "368",
    productName: "Brca1&2comprehensive Panel(full Gene +del/Dup) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 43334,
  },
  {
    id: "369",
    productName: "C Myc (all, Nhl) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5213,
  },
  {
    id: "370",
    productName: "Cardiomap - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 7234,
  },
  {
    id: "371",
    productName: "Chorionic Villus Sample For Karyotyping - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 10122,
  },
  {
    id: "372",
    productName: "Chq 13q (mm, Cll) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5213,
  },
  {
    id: "373",
    productName: "Chromosome 13 & 21 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 7956,
  },
  {
    id: "374",
    productName: "Chromosome 13, 18, 21, X & Y - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 10122,
  },
  {
    id: "375",
    productName: "Chromosome 18, X & Y (amniotic Fluid) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 7234,
  },
  {
    id: "376",
    productName: "Chromosome 21 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 6512,
  },
  {
    id: "377",
    productName:
      "Chromosome Breakage Study For Ataxia Telangiectasia - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 11747,
  },
  {
    id: "378",
    productName:
      "Chromosome Breakage Study For Blooms/Cockayne Syndrome - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 10844,
  },
  {
    id: "379",
    productName: "Chromosome Breakage Study For Fanconi’s Anemia - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 10844,
  },
  {
    id: "380",
    productName: "Chromosome Breakage Syndrome - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 7956,
  },
  {
    id: "381",
    productName: "Clinical Exome Sequencing - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 260026,
  },
  {
    id: "382",
    productName: "Cll Comprehensive Panel - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 16259,
  },
  {
    id: "383",
    productName: "Cmv Qualitative Real Time Pcr - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1600,
  },
  {
    id: "384",
    productName: "Colocore Panel 3 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 20538,
  },
  {
    id: "385",
    productName: "Coreprime Lung Panel 2 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 30338,
  },
  {
    id: "386",
    productName:
      "Crohns Disease (nod2/Card15 Gene) (r702w, G908r, 1007fs Mutations) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 16823,
  },
  {
    id: "387",
    productName:
      "Crohn’s Disease (nod2/Card15 Gene) (exon 4 Part 1-5) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 26613,
  },
  {
    id: "388",
    productName: "CRYPTOCOCCUS LATEX AGGLUTINATION",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 800,
  },
  {
    id: "389",
    productName: "Csf Fluid Analysis - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 600,
  },
  {
    id: "390",
    productName: "CSF ROUTINE ANALYSIS",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 300,
  },
  {
    id: "391",
    productName: "Dada2 (cecr1 Gene) (exons 1-10) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 47147,
  },
  {
    id: "392",
    productName: "Dgl01 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 800,
  },
  {
    id: "393",
    productName: "Dira Breakpoint Assay (175kb Deletion) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5473,
  },
  {
    id: "394",
    productName: "Dira Sequencing (il1rn Gene) (exons 1-4) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 21674,
  },
  {
    id: "395",
    productName: "Double/Triple Hit Lymphoma (solid Tumor) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 16801,
  },
  {
    id: "396",
    productName:
      "Ewings Sarcoma /Ewsr1 Gene Rearrangement (22q12) For Ewing Sarcoma - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 8678,
  },
  {
    id: "397",
    productName: "Extra-Large Biopsy (tissue Size > 6cm) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1097,
  },
  {
    id: "398",
    productName: "Fine Needle Aspiration Cytology - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 600,
  },
  {
    id: "399",
    productName: "Fish - Amli/Eto In Aml M2 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3800,
  },
  {
    id: "400",
    productName: "Fish - Bcr-Abl For Cml/Aml/All - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 4260,
  },
  {
    id: "401",
    productName: "Fish - Chromosome 13/21 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5000,
  },
  {
    id: "402",
    productName: "Fish - Chromosome 18/X/Y - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5000,
  },
  {
    id: "403",
    productName: "Fish - For Sex Chromosome Anomalies - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5000,
  },
  {
    id: "404",
    productName: "Fish - Pml/Rara In Apml - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 4058,
  },
  {
    id: "405",
    productName: "Fish – Down’s Syndrome - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5000,
  },
  {
    id: "406",
    productName:
      "Fish For 1p Loss/Deletion And 1q Gain /Amplification - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "407",
    productName: "Fish For Angelman Syndrome - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "408",
    productName:
      "Fish For Any One Microdeletion Syndrome With Karyotyping - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 6946,
  },
  {
    id: "409",
    productName: "Fish For Bcl2 (non Hodgkins Lymphoma Nhl) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "410",
    productName: "Fish For Bcl6 Breakapart Rearrangement - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "411",
    productName:
      "Fish For Bcr-Abl/Philadelphia Or Ph Chromosome/T(9;22) For All - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "412",
    productName: "Fish For Braf/7q34 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "413",
    productName:
      "Fish For Burkitt’s Lymphoma / (8q24) /(c-Myc) Rearrangement - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "414",
    productName:
      "Fish For Cll 1 Set (chr. 12 And Del 13q Or Del P53 And Del Atm) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5285,
  },
  {
    id: "415",
    productName:
      "Fish For Cll 2 Sets (chr. 12, Del 13q, Del P53 And Del Atm) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 8534,
  },
  {
    id: "416",
    productName:
      "Fish For Common Chromosomal Aneuploidies (13, 18, 21, X And Y) On Products Of Conception - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5213,
  },
  {
    id: "417",
    productName: "Fish For Cri-Du-Chat Syndrome Or 5p Deletion - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "418",
    productName: "Fish For Del 20q (20qter) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "419",
    productName: "Fish For Del 5q (egr1) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "420",
    productName: "Fish For Del 7q (d7s486) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "421",
    productName: "Fish For Deletion 22q Syndrome /Catch 22 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "422",
    productName: "Fish For Deletion Myb Or Deletion 6q - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "423",
    productName: "Fish For Deletion Of Snrpn Region - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "424",
    productName: "Fish For Edward Syndrome/Trisomy 18 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5429,
  },
  {
    id: "425",
    productName:
      "Fish For Hyper-Eosinophilic Syndrome (4q12) (fip1l1-Pdgfra) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "426",
    productName: "Fish For Igh (14q32) Rearrangement - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "427",
    productName: "Fish For Inversion 16 (cbfb)/T(16;16) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "428",
    productName: "Fish For Mll (11q23) Rearrangement - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "429",
    productName:
      "Fish For Mm Panel (chr. 12, Del 13q, Del P53 And Del Atm) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 12288,
  },
  {
    id: "430",
    productName:
      "Fish For Mm Panel (chr. 12, Del 13q, Del P53, Del Atm And Igh) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 15510,
  },
  {
    id: "431",
    productName:
      "Fish For Mm Panel Additional Probe [igh/T(4;14)/T(14;16)] - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 4707,
  },
  {
    id: "432",
    productName:
      "Fish For Mm Panel For 1 Probe Set (chr. 12, Del 13q, Or Del P53, Del Atm) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 9400,
  },
  {
    id: "433",
    productName: "Fish For Patau Syndrome/Trisomy 13 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3985,
  },
  {
    id: "434",
    productName: "Fish For Pdgfrb Breakapart Rearrangement - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "435",
    productName:
      "Fish For Post Bmt Xx/Xy Chimerism (sex Mismatched Bmt) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "436",
    productName:
      "Fish For Presence Or Absence Of Sry In Case Of Xy Female Or Xx Male - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "437",
    productName: "Fish For Rara Breakapart Rearrangement - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "438",
    productName: "Fish For Rb1 (13q) Deletion - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "439",
    productName:
      "Fish For Sex Chromosome Mosaicism (turner/Klinefelter Syndrome) From Blood  - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 4346,
  },
  {
    id: "440",
    productName:
      "Fish For Sex Chromosome Mosaicism (turner/Klinefelter Syndrome) From Buccal Cells - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 4346,
  },
  {
    id: "441",
    productName: "Fish For Sry Deletion/Translocation - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "442",
    productName: "Fish For T(1;19) Or Tcf3/Pbx1 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "443",
    productName: "Fish For T(14;16) / Igh-Maf - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "444",
    productName: "Fish For T(14;18)/ Igh-Bcl2 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "445",
    productName: "Fish For T(3;3)/Inversion 3/Rpn1-Mecom - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "446",
    productName: "Fish For T(4;14)/ Igh-Fgfr3 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "447",
    productName: "Fish For Tel-Aml /Etv6-Runx1 / T(12;21) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "448",
    productName: "Fish For Trad/14q22 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "449",
    productName: "Fish For Trisomy 8 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "450",
    productName: "Fish For Urovysion (bladder Cancer/ Hematuria) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 15090,
  },
  {
    id: "451",
    productName: "Fish For Velocardiofacial Syndrome - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "452",
    productName: "Fish For Williams Syndrome - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "453",
    productName:
      "Fish For Wolf Hirschhorn Syndrome (whs) Or 4p Deletion - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "454",
    productName: "Fish On Formalin Fixed Paraffin Embedded (ffpe) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 15659,
  },
  {
    id: "455",
    productName: "Fish Panel 2 Probe - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 9790,
  },

  {
    id: "456",
    productName: "Fish Panel 3 Probe - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 13910,
  },
  {
    id: "457",
    productName: "Fish Panel 4 Probe - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 18030,
  },
  {
    id: "458",
    productName: "Fish Panel 5 Probe - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 22150,
  },
  {
    id: "459",
    productName: "Fish Panel 6 Probe - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 26270,
  },
  {
    id: "460",
    productName: "Fish Panel 7 Probe - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 30483,
  },
  {
    id: "461",
    productName: "Fish Panel 8 Probe - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 35104,
  },
  {
    id: "462",
    productName: "Fish Panel 9 Probe - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 41313,
  },
  {
    id: "463",
    productName: "Flt3 Genotypng Test (pharmacogenomics) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3624,
  },
  {
    id: "464",
    productName: "Fluid For Malignant Cells - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 500,
  },
  {
    id: "465",
    productName: "FLUORESCENT SMEAR",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 400,
  },
  {
    id: "466",
    productName: "Fmf (mefv Gene) (exon 10, 29 Mutations) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 11538,
  },

  {
    id: "467",
    productName: "Fmf (mefv Gene) (exon 2, 5 ) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 16823,
  },
  {
    id: "468",
    productName: "Fnac - Arm/Forearm/Thigh Swelling - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 700,
  },
  {
    id: "469",
    productName: "Fnac - Back Swelling - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 700,
  },
  {
    id: "470",
    productName: "Fnac - Breast Mass - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 700,
  },
  {
    id: "471",
    productName: "Fnac - Cervical Lymph Node - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 700,
  },
  {
    id: "472",
    productName: "Fnac - Lipoma - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 700,
  },
  {
    id: "473",
    productName: "Fnac - Neck Swelling - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 700,
  },
  {
    id: "474",
    productName: "Fnac - Swelling/Tumour - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 700,
  },
  {
    id: "475",
    productName: "Fnac - Thyroid Mass - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 700,
  },
  {
    id: "476",
    productName:
      "Follicular Fluid Fish In Case Of Ivf Procedure (for X Chromosome Mosaiciasm) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5230,
  },
  {
    id: "477",
    productName: "FUNGAL CULTURE",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 300,
  },
  {
    id: "478",
    productName: "Gene Core Predict - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 32504,
  },

  {
    id: "479",
    productName: "Genecore Cancer Expanded Panel- 34 Genes - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 86654,
  },
  {
    id: "480",
    productName: "Genecore Paradigm Panel 2 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 162464,
  },

  {
    id: "481",
    productName: "Genecore Somatic 161 Gene Panel - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 48749,
  },
  {
    id: "482",
    productName: "Genecore Somatic 52 Gene Panel - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 43334,
  },
  {
    id: "483",
    productName: "Genetic Study Of Couple + Product Of Conception - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 10122,
  },
  {
    id: "484",
    productName: "GENEXPERT",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 2416,
  },
  {
    id: "485",
    productName: "Gilbert’s Syndrome Gene Sequencing. - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 7000,
  },
  {
    id: "486",
    productName: "Glioma Panel 1 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 20591,
  },
  {
    id: "487",
    productName: "GRAMS STAINING)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 300,
  },
  {
    id: "488",
    productName: "HAIR ANALYSIS PROFILE",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 2000,
  },
  {
    id: "489",
    productName: "Hbe Mutation Detection - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5285,
  },
  {
    id: "490",
    productName: "Hbs Mutation Detection For Sickle Cell Anemia - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5285,
  },
  {
    id: "491",
    productName:
      "Hbv Combo Test Including Quantitative Test And Genotyping - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 11920,
  },
  {
    id: "492",
    productName:
      "Hcv Combo Test Including Quantitative Test And Genotyping - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 11920,
  },
  {
    id: "493",
    productName: "Hemacore Mds Extended Panel - 8 Markers - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 11386,
  },
  {
    id: "494",
    productName: "Hepatitis B Genotyping And Drug Resistant Test - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5646,
  },
  {
    id: "495",
    productName: "Hepatitis C Genotyping - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 7920,
  },
  {
    id: "496",
    productName:
      "Hids/Mvk (mvk Gene) (exon 9: I268t; Exon 11 V377i) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 11538,
  },
  {
    id: "497",
    productName: "High Resolution Chromosome Study (couple) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 2500,
  },
  {
    id: "498",
    productName: "High Resolution Chromosome Study (single) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 2500,
  },
  {
    id: "499",
    productName: "Histopathology Review - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 700,
  },
  {
    id: "500",
    productName:
      "Histopathology Special Stain: Acid Fast (z N Stain) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 600,
  },
  {
    id: "501",
    productName: "Histopathology Special Stain: Amyloid (congo Red) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 750,
  },
  {
    id: "502",
    productName:
      "Histopathology Special Stain: Gomoris Methenamine Silver - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 750,
  },
  {
    id: "503",
    productName:
      "Histopathology Special Stain: Periodic Acid Schiff (pas) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 600,
  },
  {
    id: "504",
    productName: "Hiv Drug Resistance Test - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 16000,
  },
  {
    id: "505",
    productName: "Hiv Proviral Dna Qualitative Real Time Pcr - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1600,
  },
  {
    id: "506",
    productName: "Hla A, B, C, Drb1, Dqb1 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 13010,
  },
  {
    id: "507",
    productName: "Hla B-27 Qualitative Pcr - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 2000,
  },
  {
    id: "508",
    productName: "Hpv 16/18 Qualitative Real Time Pcr - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1800,
  },
  {
    id: "509",
    productName: "Hpv Qualitative Real Time Pcr - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1800,
  },
  {
    id: "510",
    productName: "Hsv I & Ii Qualitative Real Time Pcr - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 2100,
  },
  {
    id: "511",
    productName: "Ihc - 0ct3/4 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
  },
  {
    id: "512",
    productName: "Ihc - Afp - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
  },
  {
    id: "513",
    productName: "Ihc - Amacr - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
  },

  {
    id: "514",
    productName: "Ihc - Androgen Receptor - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
  },
  {
    id: "515",
    productName: "Ihc - B-Catenin - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
  },
  {
    id: "516",
    productName: "Ihc - Bcl2 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
  },
  {
    id: "517",
    productName: "Ihc - Bcl6 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
  },
  {
    id: "518",
    productName: "Ihc - Berep-4 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
  },
  {
    id: "519",
    productName: "Ihc - C-Myc - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
  },
  {
    id: "520",
    productName: "Ihc - Ca - 125 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
  },
  {
    id: "521",
    productName: "Ihc - Calcitonin - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
  },
  {
    id: "522",
    productName: "Ihc - Calponin - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
  },
  {
    id: "523",
    productName: "Ihc - Calretinin - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
  },
  {
    id: "524",
    productName: "Ihc - Cd10 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
  },
  {
    id: "525",
    productName: "Ihc - Cd117/C - Kit - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
  },
  {
    id: "526",
    productName: "Ihc - Cd138 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
  },
  {
    id: "527",
    productName: "Ihc - Cd15 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "528",
    productName: "Ihc - Cd1a - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "529",
    productName: "Ihc - Cd20 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "530",
    productName: "Ihc - Cd23 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "540",
    productName: "Ihc - Cd3 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "541",
    productName: "Ihc - Cd30 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "542",
    productName: "Ihc - Cd34 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "543",
    productName: "Ihc - Cd45(lca) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "544",
    productName: "Ihc - Cd5 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "545",
    productName: "Ihc - Cd68 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "546",
    productName: "Ihc - Cd99(mic - 2) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "547",
    productName: "Ihc - Cdx2 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "548",
    productName: "Ihc - Cea - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "549",
    productName: "Ihc - Chromogranin - A - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "550",
    productName: "Ihc - Ck - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "551",
    productName: "Ihc - Ck(hmw) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "552",
    productName: "Ihc - Ck20 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "553",
    productName: "Ihc - Ck7 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "554",
    productName: "Ihc - Cyclin - D1 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "555",
    productName: "Ihc - D2 - 40 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "556",
    productName: "Ihc - Desmin - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "557",
    productName: "Ihc - E-Cadherin - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "558",
    productName: "Ihc - Ema - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "559",
    productName: "Ihc - Gata3 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "560",
    productName: "Ihc - Gfap - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "561",
    productName: "Ihc - Glypican - 3 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "562",
    productName: "Ihc - Her-2/Nue - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "563",
    productName: "Ihc - Hmb - 45 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "564",
    productName: "Ihc - Hsa - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "565",
    productName: "Ihc - Inhibin Alpha - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "566",
    productName: "Ihc - Kappa - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "567",
    productName: "Ihc - Ki-67 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "568",
    productName: "Ihc - Lambda - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "569",
    productName: "Ihc - Mum-1 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "570",
    productName: "Ihc - Napsin A - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "571",
    productName: "Ihc - P40 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "572",
    productName: "Ihc - P53 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "573",
    productName: "Ihc - P63 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "574",
    productName: "Ihc - Pax8 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "575",
    productName: "Ihc - S-100 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "576",
    productName: "Ihc - Sall4 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "577",
    productName: "Ihc - Satb2 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "578",
    productName: "Ihc - Sma - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "579",
    productName: "Ihc - Stat6 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "580",
    productName: "Ihc - Synaptophysin - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "581",
    productName: "Ihc - Tdt - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "582",
    productName: "Ihc - Tfe3 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "583",
    productName: "Ihc - Tle- 1 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "584",
    productName: "Ihc - Ttf - 1 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "585",
    productName: "Ihc - Uroplakin Ii - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "586",
    productName: "Ihc - Vimentin - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "587",
    productName: "Ihc - Wt - 1 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "588",
    productName: "Immunohistochemistry (ihc) - 1 Marker - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "589",
    productName: "Immunohistochemistry (ihc) - 2 Markers - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 4500,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "590",
    productName: "Immunohistochemistry (ihc) - 3 Markers - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5213,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "591",
    productName: "Immunohistochemistry (ihc) - 4 Markers - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 7500,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "592",
    productName: "Immunohistochemistry (ihc) - Er/Pr - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 6000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },

  {
    id: "593",
    productName: "Jak2 Genotyping Test (pharmacogenomics) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 8140,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "594",
    productName: "K-Ras Genotyping Test (pharmacogenomics)  - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3624,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "595",
    productName: "Karyotyping - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 2500,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "596",
    productName: "Karyotyping Couples - Husband - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 2289,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "597",
    productName: "Karyotyping Couples - Wife - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 2289,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "598",
    productName: "Karyotyping For Ambiguous Genetalia - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3700,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "599",
    productName: "Large Biopsy (tissue Size > 3 < 6cm) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 736,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "600",
    productName: "LBC CERVICAL SMEAR",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1300,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "601",
    productName: "Le Cell - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 800,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "602",
    productName: "Leukemia Panel-4 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 13010,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "603",
    productName: "Liquicore Guardant360 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 324914,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "604",
    productName: "Liquicore Pik3ca - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 16259,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "605",
    productName: "Liquid Biopsy (52 Gene) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 51998,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "606",
    productName: "Low-Grade Mosaicism Detection By Fish On Blood - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 4346,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "607",
    productName:
      "Low-Grade Mosaicism Detection By Fish On Buccal Cells - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 4346,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "608",
    productName: "Low-Grade Mosaicism Detection By Fish On Urine - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 4346,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "609",
    productName: "Malignant Cells - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 400,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "610",
    productName: "Mammacore Brca Advanced Panel - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 43334,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "611",
    productName: "Mammacore Brca Advanced Plus Panel - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 54164,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "612",
    productName:
      "Mammacore Homologous Recombination Deficiency(hrr) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 32504,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "613",
    productName: "Mammacore Panel 2 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 4346,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "614",
    productName: "Medium Biopsy (tissue Size > 1 < 3cm) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 520,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "615",
    productName:
      "Metaphase Fish 22q Microdeletion-Di-George Syndrome - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "616",
    productName: "Metaphase Fish–15q–deletion-Prader Willi Syndrome - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 4000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "617",
    productName: "Microsatellite Instability (msi) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 13010,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "618",
    productName: "MISCELLANEOUS CULTURE AND SUSCEPTIBILITY",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 800,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "619",
    productName: "Mm Plasma Cell Isolation Only - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 6325,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "620",
    productName: "Modified Radicle Mastectomy -Breast - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "621",
    productName: "Modified Radicle Mastectomy -Breast With Er/Pr – (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5502,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "622",
    productName:
      "Modified Radicle Mastectomy -Breast With Er/Pr & Her-2/Nu - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 8101,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "623",
    productName: "Mthfr Mutations (c677t) And (a1298c) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 8895,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "624",
    productName: "Multiple Myeloma Comprehensive Panel - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 8678,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "625",
    productName: "Neurocore Glioseq - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 184124,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "626",
    productName: "NEWBORN SCREENING - 4",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1500,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "627",
    productName: "NEWBORN SCREENING PROFILE",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 4000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "628",
    productName: "Nipt Microdeletion - Advanced - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 26006,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "629",
    productName:
      "Nomid/Cinca/ Mws/ Fcas (nlrp3/Cias1 Gene) (exon 3, Part 1-4) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 21674,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "630",
    productName: "Non-Invasive Prenatal Testing (nipt) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 12500,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "631",
    productName: "Omega 6/3 Ratio - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 2000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "632",
    productName: "Oncomine Comprehensive Assay - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 40446,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "633",
    productName: "Oncomine Comprehensive Plus Panel - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 164630,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "634",
    productName: "Oncomine Focus Panel - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 32938,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "635",
    productName: "Oncomine Lung Cftna Cancer Panel – (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 35000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "636",
    productName:
      "Oncomine Myeloid Panel [mds, Mpn, Aml, Cml, Cmml, Jmml] - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 26006,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "637",
    productName: "Oncomine Tumor Mutation Burden (tmb) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 40446,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "638",
    productName: "Pap (papaniculaou) Smear - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 200,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "639",
    productName: "Pd-L1 (sp 142) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 10844,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "640",
    productName: "Ph -Like All Panel - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 17342,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "641",
    productName: "Pleural Fluid Analysis With Ada - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1400,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "642",
    productName: "Pleural Fluid Analysis With Afb - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 800,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "643",
    productName: "Pleural Fluid Analysis With Afb And Ada - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1500,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "644",
    productName: "Pleural Fluid Analysis With Afb And Ada - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1500,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "645",
    productName: "Pleural Fluid Cytology - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 592,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "646",
    productName: "PLM AFB DRUG SUSCEPTIBILITY ",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "647",
    productName: "Pml/Rara (aml - M3) (apml) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3913,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "648",
    productName: "Pml/Rara Qualitative (bcr 1, 2 & 3) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 4058,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "649",
    productName: "Pml/Rara Quanitative (bcr 1, 2 & 3) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5500,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "650",
    productName: "Products Of Conception (poc) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3769,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "651",
    productName: "Products Of Conception Karyotype - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 9560,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "652",
    productName: "Prothrombin Gene Mutations - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5011,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "653",
    productName: "Pulmocore basic panel - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 16259,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "654",
    productName: "Pulmocore Extended Panel - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 27089,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "655",
    productName: "Pus, Culture And Susceptibility - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 600,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "656",
    productName: "Rh Antibody Titer - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 600,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "657",
    productName: "Rubella Qualitative Real Time Pcr - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1314,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "658",
    productName: "Sickle Cells In Blood By Light Microscopy - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 800,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "659",
    productName: "Single Mutation Confirmation For Pfs - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 6166,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },

  {
    id: "660",
    productName: "Single Mutation Confirmation For Pfs - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 303,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "661",
    productName: "SMEAR AFB",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 500,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "662",
    productName: "Sperm Apoptosis (sperm Dna Fragmentation ) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 4491,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "663",
    productName: "Sperm Fish - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5400,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "664",
    productName: "SPUTUM CULTURE AND SUSCEPTIBILITY",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 800,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "665",
    productName: "Sputum For Malignant Cells - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 500,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "666",
    productName: "Sputum, Culture And Susceptibility - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 600,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "667",
    productName: "STOOL HANGING DROP",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 300,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "668",
    productName: "STOOL ROUTINE AND MICROSCOPY",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 300,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "669",
    productName:
      "Synovial Sarcoma /Ss18 Gene Rearrangement, T(x;18)(p11;q11) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 10844,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "670",
    productName: "TB - WHOLE GENOME SEQUENCING",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 8000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "671",
    productName: "TB MDR SCREEN (LPA)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 2000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "672",
    productName: "TB PCR",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1700,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "673",
    productName: "TB XDR SCREEN (LPA)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 2000,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "674",
    productName: "Tel/Aml1 (all) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 5213,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "675",
    productName: "Torch Panel Qualitative Real Time Pcr - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3913,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "676",
    productName:
      "Total Hysterectomy Of Uterus (uterus+cx+both Ft+both Ovaries) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1531,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "677",
    productName: "Toxoplasma Qualitative Real Time Pcr - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1600,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "678",
    productName:
      "Tpmt Genotyping And Toxicity Test (pharmacogenomics) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3624,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "679",
    productName: "Traps (tnfrsf1 Gene) (exons 2, 3, 4, 5) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 11538,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "680",
    productName: "Traps (tnfrsf1 Gene) (exons 6, 7) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 6166,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "681",
    productName: "Trisomy 12 (cll) - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3913,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "682",
    productName: "Trisomy 8 - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 3913,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "683",
    productName:
      "Tumour/Mass Histopathology With Surgical Margins Study - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 1500,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "684",
    productName: "Two Mutation Confirmation For Pfs - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 11538,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "685",
    productName: "Urine Occult Blood - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 200,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "686",
    productName: "Urine, Culture And Susceptibility - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 450,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "687",
    productName: "Whole Exome Sequencing - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 41602,
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
  {
    id: "688",
    productName: "Y Chromosome Microdeletion Pcr For 30 Mutations - (Outlab)",
    imgUrl: bloodTest01,
    category: "wireless",
    price: 14743,
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  },
];
